import {  EventEmitter, OnInit, Output } from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, ViewChild, inject} from '@angular/core';
import {MatAutocompleteSelectedEvent, MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { ActivatedRoute ,Router} from '@angular/router';
import { FlightService } from 'src/app/services/flight.service';
import { DataService } from 'src/app/services/data.service';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {SettingsService} from '../../services/settings.service';
import {CarrierCodeService} from '../../services/carrier-code.service';
import { UserService } from 'src/app/services/user.service';
import * as ExcelJS from 'exceljs';
import { DialogService } from 'src/app/util/dialog/dialog.service';

import { DatePipe } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialogConfig } from '@angular/material/dialog';
import { UserprofileService } from 'src/app/services/userprofile.service';
import { Pipe, PipeTransform } from '@angular/core';
import {AirConfigService}  from 'src/app/services/air-config.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { MatTabGroup } from '@angular/material/tabs';
import jwt_decode from 'jwt-decode';
import {TripService} from 'src/app/services/trip.service'

@Component({
  selector: 'app-muliti-city-flightlist',
  templateUrl: './muliti-city-flightlist.component.html',
  styleUrls: ['./muliti-city-flightlist.component.css']
})
export class MulitiCityFlightlistComponent implements OnInit {

  username:any

  airlines:any
  airlinesR:any
  airlinesT:any
  airlinesF:any
  stop:any
  stopR:any
  stopT:any
  stopF:any
  filterTime:any
  filterTimeR:any
  filterTimeT:any
  filterTimeF:any

  CancellationTab:boolean=false
  minData=new Date()
  fairRbookingDetail:any
  fairTbookingDetail:any
  fairFbookingDetail:any

  // carrierCode :any= []
  carrierCode: Map<String,any> = new Map<String,any>()

  fairbookingDetail:any
  uniqueNumbers:any
  uniqueFlightName:any
  sharePopup:boolean=false
  messageResult:any
  currentNumber: number = 1;
  ccurrentNumber: number = 0;
  icurrentNumber: number = 0;
  selectedItem: string = 'Economy';
  selectedPerson:string ='Adult'
  adult:any;
  child:any;
  Infants:any;
  journeyType="oneWay";
  separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodesTo: number[] = [ENTER, COMMA];
  announcer = inject(LiveAnnouncer);
  fromAirportError:boolean=false
  toAirportError:boolean=false
  // fruitCtrl = new FormControl('');
  // filteredFruits!: Observable<string[]>;
  // fruits: any;
  // allFruits:any = [];
  whereTo:any=[];
  showOneWay:boolean=false
  showReturn:boolean=false
  showMulti:boolean=false
  ToCtrl = new FormControl('');
  wherecity: any;
  // @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;
  @ViewChild('airportToInput') ToInput!: ElementRef<HTMLInputElement>;
  @ViewChild('pickers') datePicker!: ElementRef<HTMLInputElement>;
  dynamicTooltip:any=""
  searchFg!:FormGroup
  dates: Date[] = [];
  selectedDate: Date | null = null;
  currentDate: Date = new Date();
  messageData:any;
  departureFlight:any
returnFlight:any
thirdFlight:any
fourthFlight:any

  showPending:boolean=false
  returnflight:any
  flightDetail:any
  thirdFlightDetail:any
  fourthFlightDetail:any
  returnFlightDetail:any
  flightDetails:boolean=true
  flightDataList?: Map<String,any>
  userType:any
  viewData:boolean=false
allEmailData:any=[]
SelectedEmailData:any=[]
SelectedInboundEmail:any=[]
SelectedInboundEmailData:any=[]
SelectedTInboundEmailData:any=[]
SelectedFInboundEmailData:any=[]

userUuid:any
allInboundEmailData:any=[]
allInboundTEmailData:any=[]
allInboundFEmailData:any=[]

SelectedView:boolean=false
domIn:any={
  international:false,
  domestic:false
}
parentType:any
pointerEvents:boolean=false
  constructor(private DialogService:DialogService,private UserService:UserService,private TripService:TripService,private UserprofileService:UserprofileService,private SettingsService:SettingsService,private toastMsgService : ToastmsgService,private fb : FormBuilder,private FlightService:FlightService,private route:ActivatedRoute
    ,private router:Router,private data:DataService,private CarrierCodeService:CarrierCodeService,private AirConfigService:AirConfigService,private userInfoService : UserInfoService,) {
      this.ENABLE_TRIP_MGMT()

      let ite:string= userInfoService.getParentUser()||''
      if(ite){

        let token:any= jwt_decode(ite)

      if(token){
          this.parentType=token?.type


      }}

      this.username=userInfoService.getUsername();

      this.userType=this.userInfoService.getUserType()
      this.userType=this.userType.toUpperCase()

      this.userUuid=this.userInfoService.getUserUuid()
      this.getActiveTripList()
// console.log(this.userUuid)
      this.AirConfigService
      .getGeneralConfig(this.userUuid)
      .subscribe({
        next : (res:any) => {
          if(res) {
            let data=res
            // console.log(data[0])
           this.domIn.international=data[0]?.internationalEnabled
           this.domIn.domestic=data[0]?.domesticEnabled
          // console.log( this.domIn)

      

          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )

    this.CarrierCodeService.carrierCode().forEach(({carrierCode:code,...rest}:any)=>{
      this.carrierCode.set(code,rest)
    })
  //  this.carrierCode=this.CarrierCodeService.carrierCode()
  // this.imageData()
    this.getCorporateUsers()
   // this.getFlightList()
    this.route.queryParams.subscribe(params => {
      let data:any
      data=params
      
  });
  this.data.portMessage.subscribe((message:any) => this.messageData = message)

  this.data.deliverMsg(this.messageData)
  this.pointerEvents=this.messageData.pointerEvents

  // console.log('jhjh')
    if(this.messageData.journeyType){
      // console.log('jhjh')

      this.journeyType = this.messageData.journeyType
    }

if(this.messageData==="default message"){

}else{
  this.getFlightList()
  this.searchFlight()

}

// this.dataFields()
// this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
//   debounceTime(300), // Adjust the debounce time as needed
//   distinctUntilChanged(),
//   startWith(null),
//   map((airport: any | null) => (airport ? this._filter(airport) : this.allFruits.slice())),
// );
// this.filteredTo = this.ToCtrl.valueChanges.pipe(
//   debounceTime(300), // Adjust the debounce time as needed
//   distinctUntilChanged(),
//   startWith(null),
//   map((airports: any | null) => (airports ? this._filterTo(airports) : this.whereTo.slice())),
// );

//this.ToInput.nativeElement.value='DEL'
// this.searchFg=this.fb.group({
//       "fromAirport" :  ['',[Validators.required]],
//       "toAirport" : ['',[Validators.required]],
//       "requestedDate":[ this.messageData.airSearchRequestBaseDetails[0].requestedDate],
//       "requestedClass":[''],
//       "paxCount":[0],
//       "adultCount":[0],
//       "childCount":[0],
//       "infantCount":[0],
//       "returnDate":[this.messageData?.airSearchRequestBaseDetails[1]?.requestedDate],
//       "menu":[this.journeyType]
//     });
  }

  ngOnInit(): void {
    this.populateDates();
    this.selectedDate = this.currentDate;
   
  }
  step: number = 1;

  setStep(index: number): void {
    this.step = index;
  }
  selectDate(date: Date) {
    this.selectedDate = date;
  }

  populateDates() {
    this.dates = [];
    const weekStartDate = new Date(this.currentDate);
    weekStartDate.setDate(weekStartDate.getDate() - weekStartDate.getDay()); // Start of the current week
    for (let i = 0; i < 7; i++) {
      this.dates.push(new Date(weekStartDate));
      weekStartDate.setDate(weekStartDate.getDate() + 1); // Move to the next day
    }
  }

  navigateWeek(offset: number) {
    const newDate = new Date(this.currentDate);
    newDate.setDate(newDate.getDate() + offset * 7); // Move to the next or previous week
    this.currentDate = newDate;
    this.populateDates();
    this.selectedDate = this.currentDate;
  }
  generateJourneyKey(flightDetails: any) {
    return flightDetails
      .map((detail: any) => `${detail.flightNumber}-${detail.carrierName}`)
      .join("|");
  }
  groupAndMergeFlights(flights: any) {
    const journeyMap = new Map();

    flights.forEach((flight: any) => {
      const journeyKey = this.generateJourneyKey(flight.flightDetailsList);

      if (journeyMap.has(journeyKey)) {
        const existingJourney = journeyMap.get(journeyKey);
        flight.fare.forEach((fare: any) =>
          existingJourney.fare.push({ ...fare, source: flight.source })
        );
        existingJourney.originalFlights[flight.source] = flight;
      } else {
        journeyMap.set(journeyKey, {
          ...flight,
          flightDetails: flight.flightDetailsList,
          fare: flight.fare.map((fare: any) => ({
            ...fare,
            source: flight.source,
          })),
          originalFlights: { [flight.source]: flight },
        });
      }
    });

    return Array.from(journeyMap.values());
  }
  blankList:boolean=false
  msgError:any=''
  searchFlight() {
    this.blankList=false
    if(this.userType==='AGENT'){

    
    this.IncentiveBoolean()}
    this.enableCheck=false

    setTimeout(() => {
      this.showPending=false
     
    }, 20 * 60 * 1000);
  this.allEmailData=[]
  this.allInboundEmailData=[]
  this.allInboundTEmailData=[]
  this.allInboundFEmailData=[]
  this.SelectedEmailData=[]
  this.SelectedInboundEmailData=[]
  this.SelectedTInboundEmailData=[]
  this.SelectedFInboundEmailData=[]
    this.filterTime=null
   this.airlines=null
   this.stop=null
   this.fareType=null

   this.filterTimeR=null
   this.airlinesR=null
   this.stopR=null
   this.fareRType=null

   this.filterTimeT=null
   this.airlinesT=null
   this.stopT=null
   this.fareTType=null

   this.filterTimeF=null
   this.airlinesF=null
   this.stopF=null
   this.fareFType=null

   this.showPending=true
   let flightDetail:any=[]
   this.flightDetail=[]
   this.returnFlightDetail=[]
this.thirdFlightDetail=[]
this.fourthFlightDetail=[]
this.returnFlight=null
this.departureFlight=null
this.thirdFlight=null
this.fourthFlight=null
this.returnflight=null

   let request=JSON.parse(JSON.stringify(this.messageData))
   delete request.uuid;
if(this.messageData?.reschedule){
  let rescheduleRequest = {
  "rescheduleDate":this.messageData?.airSearchRequestBaseDetails,
    "itineraryId":this.messageData?.itineraryUuid,
    "passengerId":this.messageData?.passengerId
}
    this.FlightService.SearchRescheduleFlight(rescheduleRequest)
      .subscribe({
        next : (res) => {
         // console.log(res)
          let data:any
          data=res.body
          this.showPending=false

         
          if(data.length>0 && data[0]?.flights?.length>0 || data[1]?.flights?.length>0|| data[2]?.flights?.length>0|| data[3]?.flights?.length>0) { 
           
           
            data.forEach((flight:any)=>{
              flight.flights = this.groupAndMergeFlights(flight.flights);
             })
             
           flightDetail=data
           this.returnflight=flightDetail
           
const uniqueNumbers = new Set<number>();
const uniqueFlightName=new Set<any>();
const commonNumbers: number[] = [];
const commonFlightName: any[] = [];

for(let i=0;i< this.returnflight[0].flights.length;i++){
  // this.returnflight[0].flights[i].schArrivalTime=this.returnflight[0].flights[i].schArrivalTime.replace(' ','T')
  // this.returnflight[0].flights[i].schDepartureTime=this.returnflight[0].flights[i].schDepartureTime.replace(' ','T')

  // for(let t=0;t< this.returnflight[0].flights[i].flightDetailsList.length;t++){

  // this.returnflight[0].flights[i].flightDetailsList[t].schArrivalTime=this.returnflight[0].flights[i].flightDetailsList[t].schArrivalTime.replace(' ','T')
  // this.returnflight[0].flights[i].flightDetailsList[t].schDepartureTime=this.returnflight[0].flights[i].flightDetailsList[t].schDepartureTime.replace(' ','T')

  // }
  
this.returnflight[0].flights[i].flightDetailsList.forEach((equip:any)=>
{

//   this.FlightService
//   .getEquipment(equip.equipmentType)
// .subscribe({
//   next : (res:any) => {
//     if(res) {
//       let data:any
//       data=res
//       equip.equipmentName= data?.name
//     } else {
//       equip.equipmentName =equip?.equipmentType

//     } 
//   },error : (err) => {
//     return equip?.equipmentType

//   }
// }
// )
}

)

  if (uniqueFlightName.has(this.returnflight[0].flights[i].flightDetailsList[0].carrierName)){
    // If the number is already in the set, it's a common number
    commonFlightName.push(this.returnflight[0].flights[i].flightDetailsList[0].carrierName);
  } else {
    // Otherwise, add it to the set
    uniqueFlightName.add(this.returnflight[0].flights[i].flightDetailsList[0].carrierName);
  }
// Iterate through the array

  if (uniqueNumbers.has(this.returnflight[0].flights[i].hopCount)) {
    // If the number is already in the set, it's a common number
    commonNumbers.push(this.returnflight[0].flights[i].hopCount);
  } else {
    // Otherwise, add it to the set
    uniqueNumbers.add(this.returnflight[0].flights[i].hopCount);
  }
  
          }

const uniqueRNumbers = new Set<number>();
const commonRNumbers: number[] = [];
const uniqueRFlightName=new Set<any>();
const commonRFlightName: any[] = [];
let combinedSet:any
let combinedFlightSet:any
if(this.returnflight[1]){
for(let i=0;i< this.returnflight[1].flights.length;i++){
  this.returnflight[1].flights[i].flightDetailsList.forEach((equip:any)=>
  {
  //   this.FlightService
  //   .getEquipment(equip.equipmentType)
  // .subscribe({
  //   next : (res:any) => {
  //     if(res) {
  //       let data:any
  //       data=res
  //       equip.equipmentName= data?.name
  
  //     } else {
  //       equip.equipmentName =equip?.equipmentType
  
  //     } 
  //   },error : (err) => {
  //     return equip?.equipmentType
  
  //   }
  // }
  // )
  }
  )
  if (uniqueRFlightName.has(this.returnflight[1].flights[i].flightDetailsList[0].carrierName)){
    // If the number is already in the set, it's a common number
    commonRFlightName.push(this.returnflight[1].flights[i].flightDetailsList[0].carrierName);
  } else {
    // Otherwise, add it to the set
    uniqueRFlightName.add(this.returnflight[1].flights[i].flightDetailsList[0].carrierName);
  }

// Iterate through the array

  if (uniqueRNumbers.has(this.returnflight[1].flights[i].hopCount)) {
    // If the number is already in the set, it's a common number
    commonRNumbers.push(this.returnflight[1].flights[i].hopCount);
  } else {
    // Otherwise, add it to the set
    uniqueRNumbers.add(this.returnflight[1].flights[i].hopCount);
  }
  

          }}
          combinedSet = new Set([...uniqueNumbers, ...uniqueRNumbers]);
          

          this.uniqueNumbers=combinedSet

          combinedFlightSet= new Set([...uniqueFlightName, ...uniqueRFlightName]);
          this.uniqueFlightName=combinedFlightSet
       //   console.log(commonNumbers)
  //console.log(this.uniqueNumbers)
           this.ActiveDeparture=this.returnflight[0]?.flights[0]
           this.ActiveReturn=this.returnflight[1]?.flights[0]
           this.ActiveThird=this.returnflight[2]?.flights[0]
           this.ActiveFourth=this.returnflight[3]?.flights[0]
           this.departureFlight={...this.returnflight[0]?.flights[0]}
           this.departureFlight.fare=[{...this.returnflight[0]?.flights[0].fare[0]}]
           if(this.returnflight[1]?.flights[0]){
            this.returnFlight={...this.returnflight[1]?.flights[0]}
            this.returnFlight.fare=[{...this.returnflight[1]?.flights[0].fare[0]}]
           }
           if(this.returnflight[2]?.flights[0]){
            this.thirdFlight={...this.returnflight[2]?.flights[0]}
            this.thirdFlight.fare=[{...this.returnflight[2]?.flights[0].fare[0]}]
           }
           if(this.returnflight[3]?.flights[0]){
            this.fourthFlight={...this.returnflight[3]?.flights[0]}
            this.fourthFlight.fare=[{...this.returnflight[3]?.flights[0].fare[0]}]
           }
           
           
           for(let i=0;i<flightDetail[0].flights.length;i++){
            flightDetail[0].flights[i].dropDown=false
            flightDetail[0].flights[i].selected=false
            flightDetail[0].flights[i].fare.forEach(function(item: any) {item.selected=''})
            flightDetail[0].flights[i].fare.forEach((item: any, index: number) => {
              item.number = index;
            });
               
          }
          flightDetail[0].flights[0].selected=true

          flightDetail[0].flights[0].fare[0].selected='true'
          this.onClickFare(flightDetail[0].flights[0].fare[0],flightDetail[0].flights[0].fare,flightDetail[0].flights[0])

          this.multiSelectedTAB=0
          if(flightDetail[1]){
            if(flightDetail[1].flights.length>0){

          for(let i=0;i<flightDetail[1].flights.length;i++){
            flightDetail[1].flights[i].dropDown=false
            flightDetail[1].flights[i].selected=false
            flightDetail[1].flights[i].fare.forEach(function(item: any) {item.selected=''})
            flightDetail[1].flights[i].fare.forEach((item: any, index: number) => {
              item.number = index;
            });
            
               
          }
          flightDetail[1].flights[0].selected=true

          flightDetail[1].flights[0].fare[0].selected='true'
          this.returnFlightDetail=flightDetail[1].flights
          this.onClickRFare(flightDetail[1].flights[0].fare[0],flightDetail[1].flights[0].fare,flightDetail[1].flights[0])
        }
        }
          
        
        if(flightDetail[2]){
          if(flightDetail[2].flights.length>0){

          for(let i=0;i<flightDetail[2].flights.length;i++){
            flightDetail[2].flights[i].dropDown=false
            flightDetail[2].flights[i].selected=false
            flightDetail[2].flights[i].fare.forEach(function(item: any) {item.selected=''})
            flightDetail[2].flights[i].fare.forEach((item: any, index: number) => {
              item.number = index;
            });
            
               
          }
          flightDetail[2].flights[0].selected=true

          flightDetail[2].flights[0].fare[0].selected='true'
          this.thirdFlightDetail=flightDetail[2].flights
          this.onClickTFare(flightDetail[2].flights[0].fare[0],flightDetail[2].flights[0].fare,flightDetail[2].flights[0])
        }
        }
        if(flightDetail[3]){
          if(flightDetail[3].flights.length>0){

          for(let i=0;i<flightDetail[3].flights.length;i++){
            flightDetail[3].flights[i].dropDown=false
            flightDetail[3].flights[i].selected=false
            flightDetail[3].flights[i].fare.forEach(function(item: any) {item.selected=''})
            flightDetail[3].flights[i].fare.forEach((item: any, index: number) => {
              item.number = index;
            });
            
               
          }
          flightDetail[3].flights[0].selected=true

          flightDetail[3].flights[0].fare[0].selected='true'
          this.fourthFlightDetail=flightDetail[3].flights
          this.onClickFFare(flightDetail[3].flights[0].fare[0],flightDetail[3].flights[0].fare,flightDetail[3].flights[0])
        }
        }

           this.flightDetail=flightDetail[0].flights
           
        this.calculateMinMaxPrices()
        this.fareTypeFilter()
        this.fareRTypeFilter()
        this.fareTTypeFilter()
        this.fareFTypeFilter()

        if(this.messageData.airSearchRequestBaseDetails[0]?.travelTime){
  this.filterTime=this.messageData.airSearchRequestBaseDetails[0]?.travelTime||null
  this.combineFilters()
        }
        if(this.messageData.airSearchRequestBaseDetails[1]?.travelTime){
  this.filterTimeR=this.messageData.airSearchRequestBaseDetails[1]?.travelTime||null
  this.combineRFilters()
        }
        if(this.messageData.airSearchRequestBaseDetails[2]?.travelTime){
  this.filterTimeT=this.messageData.airSearchRequestBaseDetails[2]?.travelTime||null
  this.combineTFilters()
        }
        if(this.messageData.airSearchRequestBaseDetails[3]?.travelTime){
  this.filterTimeF=this.messageData.airSearchRequestBaseDetails[3]?.travelTime||null
  this.combineFFilters()
        }

        this.countdown = 300;
        clearInterval(this.interval);

            this.startTimer();
          } else {
            this.getFlightList()
            this.showPending=false
            // this.router.navigate(["/app/flight"]);
            this.blankList=true
            // this.toastMsgService.setMsg({msg : "Sorry, there are no matching results ",msgTitle:  "Warning", msgType : "W"});

          } 
          
        },error : (err) => {
          
          this.getFlightList()
          this.showPending=false
          this.blankList=true
  this.msgError=err?.error?.errorMessage
           this.toastMsgService.setMsg({ msg:err?.error?.errorMessage , msgTitle: "Warning", msgType: "W" });

          //this.router.navigate(["/app/flight"]);
          // this.toastMsgService.setMsg({msg : "Sorry, there are no matching results ",msgTitle:  "Warning", msgType : "W"});

        }
      }
    )}else{
      this.FlightService.SearchFlight(request)
      .subscribe({
        next : (res) => {
         // console.log(res)
          let data:any
          data=res.body
          this.showPending=false

         
          if(data.length>0 && data[0]?.flights?.length>0 || data[1]?.flights?.length>0|| data[2]?.flights?.length>0|| data[3]?.flights?.length>0) { 
           
           
            data.forEach((flight:any)=>{
              flight.flights = this.groupAndMergeFlights(flight.flights);
             })
             
           flightDetail=data
           this.returnflight=flightDetail
           
const uniqueNumbers = new Set<number>();
const uniqueFlightName=new Set<any>();
const commonNumbers: number[] = [];
const commonFlightName: any[] = [];

for(let i=0;i< this.returnflight[0].flights.length;i++){
  // this.returnflight[0].flights[i].schArrivalTime=this.returnflight[0].flights[i].schArrivalTime.replace(' ','T')
  // this.returnflight[0].flights[i].schDepartureTime=this.returnflight[0].flights[i].schDepartureTime.replace(' ','T')

  // for(let t=0;t< this.returnflight[0].flights[i].flightDetailsList.length;t++){

  // this.returnflight[0].flights[i].flightDetailsList[t].schArrivalTime=this.returnflight[0].flights[i].flightDetailsList[t].schArrivalTime.replace(' ','T')
  // this.returnflight[0].flights[i].flightDetailsList[t].schDepartureTime=this.returnflight[0].flights[i].flightDetailsList[t].schDepartureTime.replace(' ','T')

  // }
  
this.returnflight[0].flights[i].flightDetailsList.forEach((equip:any)=>
{

//   this.FlightService
//   .getEquipment(equip.equipmentType)
// .subscribe({
//   next : (res:any) => {
//     if(res) {
//       let data:any
//       data=res
//       equip.equipmentName= data?.name
//     } else {
//       equip.equipmentName =equip?.equipmentType

//     } 
//   },error : (err) => {
//     return equip?.equipmentType

//   }
// }
// )
}

)

  if (uniqueFlightName.has(this.returnflight[0].flights[i].flightDetailsList[0].carrierName)){
    // If the number is already in the set, it's a common number
    commonFlightName.push(this.returnflight[0].flights[i].flightDetailsList[0].carrierName);
  } else {
    // Otherwise, add it to the set
    uniqueFlightName.add(this.returnflight[0].flights[i].flightDetailsList[0].carrierName);
  }
// Iterate through the array

  if (uniqueNumbers.has(this.returnflight[0].flights[i].hopCount)) {
    // If the number is already in the set, it's a common number
    commonNumbers.push(this.returnflight[0].flights[i].hopCount);
  } else {
    // Otherwise, add it to the set
    uniqueNumbers.add(this.returnflight[0].flights[i].hopCount);
  }
  
          }

const uniqueRNumbers = new Set<number>();
const commonRNumbers: number[] = [];
const uniqueRFlightName=new Set<any>();
const commonRFlightName: any[] = [];
let combinedSet:any
let combinedFlightSet:any
if(this.returnflight[1]){
for(let i=0;i< this.returnflight[1].flights.length;i++){
  this.returnflight[1].flights[i].flightDetailsList.forEach((equip:any)=>
  {
  //   this.FlightService
  //   .getEquipment(equip.equipmentType)
  // .subscribe({
  //   next : (res:any) => {
  //     if(res) {
  //       let data:any
  //       data=res
  //       equip.equipmentName= data?.name
  
  //     } else {
  //       equip.equipmentName =equip?.equipmentType
  
  //     } 
  //   },error : (err) => {
  //     return equip?.equipmentType
  
  //   }
  // }
  // )
  }
  )
  if (uniqueRFlightName.has(this.returnflight[1].flights[i].flightDetailsList[0].carrierName)){
    // If the number is already in the set, it's a common number
    commonRFlightName.push(this.returnflight[1].flights[i].flightDetailsList[0].carrierName);
  } else {
    // Otherwise, add it to the set
    uniqueRFlightName.add(this.returnflight[1].flights[i].flightDetailsList[0].carrierName);
  }

// Iterate through the array

  if (uniqueRNumbers.has(this.returnflight[1].flights[i].hopCount)) {
    // If the number is already in the set, it's a common number
    commonRNumbers.push(this.returnflight[1].flights[i].hopCount);
  } else {
    // Otherwise, add it to the set
    uniqueRNumbers.add(this.returnflight[1].flights[i].hopCount);
  }
  

          }}
          combinedSet = new Set([...uniqueNumbers, ...uniqueRNumbers]);
          

          this.uniqueNumbers=combinedSet

          combinedFlightSet= new Set([...uniqueFlightName, ...uniqueRFlightName]);
          this.uniqueFlightName=combinedFlightSet
       //   console.log(commonNumbers)
  //console.log(this.uniqueNumbers)
           this.ActiveDeparture=this.returnflight[0]?.flights[0]
           this.ActiveReturn=this.returnflight[1]?.flights[0]
           this.ActiveThird=this.returnflight[2]?.flights[0]
           this.ActiveFourth=this.returnflight[3]?.flights[0]
           this.departureFlight={...this.returnflight[0]?.flights[0]}
           this.departureFlight.fare=[{...this.returnflight[0]?.flights[0].fare[0]}]
           if(this.returnflight[1]?.flights[0]){
            this.returnFlight={...this.returnflight[1]?.flights[0]}
            this.returnFlight.fare=[{...this.returnflight[1]?.flights[0].fare[0]}]
           }
           if(this.returnflight[2]?.flights[0]){
            this.thirdFlight={...this.returnflight[2]?.flights[0]}
            this.thirdFlight.fare=[{...this.returnflight[2]?.flights[0].fare[0]}]
           }
           if(this.returnflight[3]?.flights[0]){
            this.fourthFlight={...this.returnflight[3]?.flights[0]}
            this.fourthFlight.fare=[{...this.returnflight[3]?.flights[0].fare[0]}]
           }
           
           
           for(let i=0;i<flightDetail[0].flights.length;i++){
            flightDetail[0].flights[i].dropDown=false
            flightDetail[0].flights[i].selected=false
            flightDetail[0].flights[i].fare.forEach(function(item: any) {item.selected=''})
            flightDetail[0].flights[i].fare.forEach((item: any, index: number) => {
              item.number = index;
            });
               
          }
          flightDetail[0].flights[0].selected=true

          flightDetail[0].flights[0].fare[0].selected='true'
          this.onClickFare(flightDetail[0].flights[0].fare[0],flightDetail[0].flights[0].fare,flightDetail[0].flights[0])

          this.multiSelectedTAB=0
          if(flightDetail[1]){
            if(flightDetail[1].flights.length>0){

          for(let i=0;i<flightDetail[1].flights.length;i++){
            flightDetail[1].flights[i].dropDown=false
            flightDetail[1].flights[i].selected=false
            flightDetail[1].flights[i].fare.forEach(function(item: any) {item.selected=''})
            flightDetail[1].flights[i].fare.forEach((item: any, index: number) => {
              item.number = index;
            });
            
               
          }
          flightDetail[1].flights[0].selected=true

          flightDetail[1].flights[0].fare[0].selected='true'
          this.returnFlightDetail=flightDetail[1].flights
          this.onClickRFare(flightDetail[1].flights[0].fare[0],flightDetail[1].flights[0].fare,flightDetail[1].flights[0])
        }
        }
          
        
        if(flightDetail[2]){
          if(flightDetail[2].flights.length>0){

          for(let i=0;i<flightDetail[2].flights.length;i++){
            flightDetail[2].flights[i].dropDown=false
            flightDetail[2].flights[i].selected=false
            flightDetail[2].flights[i].fare.forEach(function(item: any) {item.selected=''})
            flightDetail[2].flights[i].fare.forEach((item: any, index: number) => {
              item.number = index;
            });
            
               
          }
          flightDetail[2].flights[0].selected=true

          flightDetail[2].flights[0].fare[0].selected='true'
          this.thirdFlightDetail=flightDetail[2].flights
          this.onClickTFare(flightDetail[2].flights[0].fare[0],flightDetail[2].flights[0].fare,flightDetail[2].flights[0])
        }
        }
        if(flightDetail[3]){
          if(flightDetail[3].flights.length>0){

          for(let i=0;i<flightDetail[3].flights.length;i++){
            flightDetail[3].flights[i].dropDown=false
            flightDetail[3].flights[i].selected=false
            flightDetail[3].flights[i].fare.forEach(function(item: any) {item.selected=''})
            flightDetail[3].flights[i].fare.forEach((item: any, index: number) => {
              item.number = index;
            });
            
               
          }
          flightDetail[3].flights[0].selected=true

          flightDetail[3].flights[0].fare[0].selected='true'
          this.fourthFlightDetail=flightDetail[3].flights
          this.onClickFFare(flightDetail[3].flights[0].fare[0],flightDetail[3].flights[0].fare,flightDetail[3].flights[0])
        }
        }

           this.flightDetail=flightDetail[0].flights
           
        this.calculateMinMaxPrices()
        this.fareTypeFilter()
        this.fareRTypeFilter()
        this.fareTTypeFilter()
        this.fareFTypeFilter()

        if(this.messageData.airSearchRequestBaseDetails[0]?.travelTime){
  this.filterTime=this.messageData.airSearchRequestBaseDetails[0]?.travelTime||null
  this.combineFilters()
        }
        if(this.messageData.airSearchRequestBaseDetails[1]?.travelTime){
  this.filterTimeR=this.messageData.airSearchRequestBaseDetails[1]?.travelTime||null
  this.combineRFilters()
        }
        if(this.messageData.airSearchRequestBaseDetails[2]?.travelTime){
  this.filterTimeT=this.messageData.airSearchRequestBaseDetails[2]?.travelTime||null
  this.combineTFilters()
        }
        if(this.messageData.airSearchRequestBaseDetails[3]?.travelTime){
  this.filterTimeF=this.messageData.airSearchRequestBaseDetails[3]?.travelTime||null
  this.combineFFilters()
        }

        this.countdown = 300;
        clearInterval(this.interval);

            this.startTimer();
          } else {
            this.getFlightList()
            this.showPending=false
            // this.router.navigate(["/app/flight"]);
            this.blankList=true
            // this.toastMsgService.setMsg({msg : "Sorry, there are no matching results ",msgTitle:  "Warning", msgType : "W"});

          } 
          
        },error : (err) => {
          
          this.getFlightList()
          this.showPending=false
          this.blankList=true

          //this.router.navigate(["/app/flight"]);
          // this.toastMsgService.setMsg({msg : "Sorry, there are no matching results ",msgTitle:  "Warning", msgType : "W"});

        }
      }
    )
    }
  }


  converter(item:any){
    const totalMinutes = item ;
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    item=`${hours}h ${remainingMinutes}m`
    return item
  }

  convertInTime(item:any){
    
const hours = Math.floor(item / 100);
const minutes = item % 100;
const ampm = hours >= 12 ? 'PM' : 'AM';
const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}${ampm}`;


    
item=formattedTime;
    return item
  }
  formatTimeComponent(component: number): string {
    return component < 10 ? `0${component}` : component.toString();
  }


  
  

  getFlightList(){
   
    this.FlightService
    .getFlightList()
    .subscribe({
      next : (res:any) => {
        if(res) {
        //  let data:any
        //  data=res  
        //  this.flightDataList=data
         let data: Array<any>;
         data = res
         let mappedDataWithIataCode:Map<String,any>=new Map<String,any>();
         
          data.forEach(({iataCode,...rest})=>{
           mappedDataWithIataCode.set(iataCode,rest);
          });
         this.flightDataList=mappedDataWithIataCode;
      // for (let i = 0; i < data.length; i++) {
      //   this.allFruits.push(data[i]?.iataCode+`\u00A0 `+data[i]?.city+`,`+data[i]?.country+` - `+data[i]?.name);
      //   this.whereTo.push(data[i]?.iataCode+`\u00A0 `+data[i]?.city+`,`+data[i]?.country+` - `+data[i]?.name);
      //  }
      //  let toAirData= data.filter((itm: { iataCode: any; })=>itm.iataCode === this.messageData.airSearchRequestBaseDetails[0].toAirport)
      //  toAirData=toAirData[0]?.iataCode+`\u00A0 `+toAirData[0]?.city+`,`+toAirData[0]?.country+` - `+toAirData[0]?.name
      
      //  const  fromAirportDataRaw = data.filter((itm:any)=>itm?.iataCode===this.messageData?.airSearchRequestBaseDetails[0]?.fromAirport);
      
      //  let fromAirportData = fromAirportDataRaw[0];
      //  let fromAirportString:any = fromAirportData?.iataCode+`\u00A0 `+fromAirportData?.city+`,`+fromAirportData?.country+` - `+fromAirportData?.name
      //  this.fruitInput.nativeElement.value =   fromAirportString     //toAirData={option:{viewValue:toAirData}}
      //  this.fruits=fromAirportString;
      //  this.fromAirportError=false
      //  this.fruitCtrl.setValue(null);

      //  const  toAirportDataRaw = data.filter((itm:any)=>itm.iataCode===this.messageData.airSearchRequestBaseDetails[0].toAirport);
      //  let toAirportData = toAirportDataRaw[0];
      //  let toAirportString = toAirportData?.iataCode+`\u00A0 `+toAirportData?.city+`,`+toAirportData?.country+` - `+toAirportData?.name
      //  this.ToInput.nativeElement.value =   toAirportString     //toAirData={option:{viewValue:toAirData}}
      //  this.wherecity=toAirportString;
      //  this.fromAirportError=false
      //  this.ToCtrl.setValue(null);
      

       
       
      

       
    
        } else {    
        } 
      },error : (err) => {

        
      }
    }
  )
  }




  getSelectedFareOriginalFlight(journeyData:any, selectedFare:any) {
    const originalFlight = journeyData.originalFlights[selectedFare.source];

    if (originalFlight) {
        return {
            ...originalFlight,
            fare: [selectedFare]  
        };
    }
    return null;  
}
  openReturnWindow(){
    let flightDetail:any={}
    let returnDetail:any={}
    let thirdDetail:any={}
    let fourthDetail:any={}
    console.log(this.fairbookingDetail)
    let selectFight = this.getSelectedFareOriginalFlight(this.departureFlight, this.fairbookingDetail)
    flightDetail = selectFight;
    // flightDetail={...this.departureFlight}
    // if(this.fairbookingDetail){
     
    //   flightDetail.fare=[this.fairbookingDetail]
    // }
    if(this.returnFlight){
    let selectRFight = this.getSelectedFareOriginalFlight(this.returnFlight, this.fairRbookingDetail)
    returnDetail = selectRFight;}
    // returnDetail={...this.returnFlight}
    
    // if(this.fairRbookingDetail){
    //   returnDetail.fare=[{...this.fairRbookingDetail}]
    // }
if(this.thirdFlight){
  let selectTFight = this.getSelectedFareOriginalFlight(this.thirdFlight, this.fairTbookingDetail)
  thirdDetail = selectTFight;
}
   
    // thirdDetail={...this.thirdFlight}

    // if(this.fairTbookingDetail){
    //   thirdDetail.fare=[{...this.fairTbookingDetail}]
    // }
    if(this.fourthFlight){
    let selectFFight = this.getSelectedFareOriginalFlight(this.fourthFlight, this.fairFbookingDetail)
    fourthDetail = selectFFight;}
    // fourthDetail={...this.fourthFlight}

    // if(this.fairFbookingDetail){
    //   fourthDetail.fare=[{...this.fairFbookingDetail}]
    // }


    let travellerDetails={child:this.messageData.childCount,
      adult:this.messageData.adultCount,
     infantCount:this.messageData.infantCount,}




    //  let url= "/app/book?flightBooking="+JSON.stringify(flightDetail)+"&returnDetail="+JSON.stringify(returnDetail)+"&travellerDetails="+JSON.stringify(travellerDetails);
    //  window.open(url);
     let orderData:any
     if( this.departureFlight&&!this.returnFlight&&!this.thirdFlight&&!this.fourthFlight){
      orderData={flightBooking:[flightDetail],travellerDetails:travellerDetails}
     
      orderData.flightBooking[0].fromAirport=flightDetail.flightDetailsList[0].fromAirport
      orderData.flightBooking[0].toAirport=flightDetail.flightDetailsList[flightDetail.flightDetailsList.length-1].toAirport
    
    }else if(this.departureFlight&&this.returnFlight&&!this.thirdFlight&&!this.fourthFlight){
    
      orderData={flightBooking:[flightDetail,returnDetail],travellerDetails:travellerDetails}
     
     
      orderData.flightBooking[0].fromAirport=flightDetail.flightDetailsList[0].fromAirport
      orderData.flightBooking[0].toAirport=flightDetail.flightDetailsList[flightDetail.flightDetailsList.length-1].toAirport
      
      orderData.flightBooking[1].fromAirport=returnDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBooking[1].toAirport=returnDetail.flightDetailsList[returnDetail.flightDetailsList.length-1].toAirport
     
    }else if(this.departureFlight&&this.returnFlight&&this.thirdFlight&&!this.fourthFlight){
    
      orderData={flightBooking:[flightDetail,returnDetail,thirdDetail],travellerDetails:travellerDetails}
     
     
      orderData.flightBooking[0].fromAirport=flightDetail.flightDetailsList[0].fromAirport
      orderData.flightBooking[0].toAirport=flightDetail.flightDetailsList[flightDetail.flightDetailsList.length-1].toAirport
      
      orderData.flightBooking[1].fromAirport=returnDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBooking[1].toAirport=returnDetail.flightDetailsList[returnDetail.flightDetailsList.length-1].toAirport
      orderData.flightBooking[2].fromAirport=thirdDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBooking[2].toAirport=thirdDetail.flightDetailsList[thirdDetail.flightDetailsList.length-1].toAirport
     
    }
    else if(this.departureFlight&&this.returnFlight&&this.thirdFlight&&this.fourthFlight){
    
      orderData={flightBooking:[flightDetail,returnDetail,thirdDetail,fourthDetail],travellerDetails:travellerDetails}
     
      orderData.flightBooking[0].fromAirport=flightDetail.flightDetailsList[0].fromAirport
      orderData.flightBooking[0].toAirport=flightDetail.flightDetailsList[flightDetail.flightDetailsList.length-1].toAirport
      
      orderData.flightBooking[1].fromAirport=returnDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBooking[1].toAirport=returnDetail.flightDetailsList[returnDetail.flightDetailsList.length-1].toAirport
      orderData.flightBooking[2].fromAirport=thirdDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBooking[2].toAirport=thirdDetail.flightDetailsList[thirdDetail.flightDetailsList.length-1].toAirport
      orderData.flightBooking[3].fromAirport=fourthDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBooking[3].toAirport=fourthDetail.flightDetailsList[fourthDetail.flightDetailsList.length-1].toAirport
    }


     this.generateOrder(orderData);
  }
  onewayBoolean:boolean=false
  returnBoolean:boolean=false
  thirdBoolean:boolean=false
  fourthBoolean:boolean=false

  openReturnPopup(onewayBoolean:any,returnBoolean:any,thirdBoolean:any,fourthBoolean:any){

this.onewayBoolean=onewayBoolean
this.returnBoolean=returnBoolean
this.thirdBoolean=thirdBoolean
this.fourthBoolean=fourthBoolean
    this.flightDetails=false

    this.getFareRules()
    this.getRFareRules()
    this.getTFareRules()
    this.getFFareRules()
    this.getrepriceData(JSON.parse(JSON.stringify(this.departureFlight)),JSON.parse(JSON.stringify(this.returnFlight)),JSON.parse(JSON.stringify(this.thirdFlight)),JSON.parse(JSON.stringify(this.fourthFlight)))


   }

   onClickRFare(fare:any,item:any,items:any){
    this.step=1
    if(this.returnflight[1]){
      for(let i=0;i<this.returnflight[1].flights.length;i++){
        // this.returnflight[0].flights[i].dropDown=false
        this.returnflight[1].flights[i].selected=false
      }}

      this.activeReturn(items)

    //console.log(item)
    
     for(let flight of this.returnFlightDetail){
      flight.selected=false
      for(let i=0;i<flight.fare.length;i++){
        flight.fare[i].selected=''

      }
    }
    items.selected=true

   for(let i=0;i<item.length;i++){
     
     item[i].selected=''
   
   }
  fare.selected='true'
 
   
   this.fairRbookingDetail=fare

   this.returnFlight={ ...items }
   this.returnFlight.fare=[{...this.fairRbookingDetail}]


   this.getRFareRules()
   this.getrepriceData(JSON.parse(JSON.stringify(this.departureFlight)),JSON.parse(JSON.stringify(this.returnFlight)),JSON.parse(JSON.stringify(this.thirdFlight)),JSON.parse(JSON.stringify(this.fourthFlight)))

 }




   onClickTFare(fare:any,item:any,items:any){
    this.step=1
    
    //console.log(item)
    if(this.returnflight[2]){
      for(let i=0;i<this.returnflight[2].flights.length;i++){
        // this.returnflight[0].flights[i].dropDown=false
        this.returnflight[2].flights[i].selected=false
      }}

      this.activeThird(items)    
     for(let flight of this.thirdFlightDetail){
      flight.selected=false
      for(let i=0;i<flight.fare.length;i++){
        flight.fare[i].selected=''

      }
    }
    items.selected=true

   for(let i=0;i<item.length;i++){
     
     item[i].selected=''
   
   }
  fare.selected='true'
 
   
   this.fairTbookingDetail=fare
   this.thirdFlight={ ...items }
   this.thirdFlight.fare=[{...this.fairTbookingDetail}]
   this.getTFareRules()
   this.getrepriceData(JSON.parse(JSON.stringify(this.departureFlight)),JSON.parse(JSON.stringify(this.returnFlight)),JSON.parse(JSON.stringify(this.thirdFlight)),JSON.parse(JSON.stringify(this.fourthFlight)))

 }
 onClickFFare(fare:any,item:any,items:any){
  this.step=1
  
  //console.log(item)
  if(this.returnflight[3]){
    for(let i=0;i<this.returnflight[3].flights.length;i++){
      // this.returnflight[0].flights[i].dropDown=false
      this.returnflight[3].flights[i].selected=false
    }}

    this.activeFourth(items)   
   for(let flight of this.fourthFlightDetail){
    flight.selected=false
    for(let i=0;i<flight.fare.length;i++){
      flight.fare[i].selected=''

    }
  }
  items.selected=true

 for(let i=0;i<item.length;i++){
   
   item[i].selected=''
 
 }
fare.selected='true'

 
 this.fairFbookingDetail=fare
 this.fourthFlight={ ...items }
   this.fourthFlight.fare=[{...this.fairFbookingDetail}]
 this.getFFareRules()
 this.getrepriceData(JSON.parse(JSON.stringify(this.departureFlight)),JSON.parse(JSON.stringify(this.returnFlight)),JSON.parse(JSON.stringify(this.thirdFlight)),JSON.parse(JSON.stringify(this.fourthFlight)))

}



  onClickFare(fare:any,item:any,items:any){


    this.step=1
    if(this.returnflight[0]){
      for(let i=0;i<this.returnflight[0].flights.length;i++){
        // this.returnflight[0].flights[i].dropDown=false
        this.returnflight[0].flights[i].selected=false
      }}
      // items.dropDown=true
      this.activeDeparture(items)
    for(let flight of this.flightDetail){
      flight.selected=false
      for(let i=0;i<flight.fare.length;i++){
        flight.fare[i].selected=''

      }
    }
    items.selected=true

  for(let i=0;i<item.length;i++){
    
    item[i].selected=''
  
   
  }
  // console.log(item)

  fare.selected='true'

  this.fairbookingDetail=fare
 this.departureFlight={ ...items }
  this.departureFlight.fare=[{...this.fairbookingDetail}]

  this.getFareRules()
  // console.log(this.departureFlight)
  this.getrepriceData(JSON.parse(JSON.stringify(this.departureFlight)),JSON.parse(JSON.stringify(this.returnFlight)),JSON.parse(JSON.stringify(this.thirdFlight)),JSON.parse(JSON.stringify(this.fourthFlight)))

}

  openWindow(item:any):void{
    this.step=0
    let flightDetail:any={}
    let returnDetail:any={}
    flightDetail={...this.departureFlight}
    if(this.fairbookingDetail){
     
      flightDetail.fare=[this.fairbookingDetail]
    }
  let travellerDetails={child:this.messageData.childCount,
    adult:this.messageData.adultCount,
   infantCount:this.messageData.infantCount,}
    
    //  let url= "/app/book?flightBooking="+JSON.stringify(flightDetail)+"&returnDetail="+JSON.stringify(returnDetail)+"&travellerDetails="+JSON.stringify(travellerDetails);
    //  window.open(url);
     let orderData:any
    //  console.log(returnDetail)

if( Object.keys(returnDetail).length === 0){
  // console.log("one")
  orderData={flightBooking:[flightDetail],travellerDetails:travellerDetails}
  orderData.flightBooking[0].fromAirport=this.returnflight[0].fromAirport
  orderData.flightBooking[0].toAirport=this.returnflight[0].toAirport
  
 
}else{
  // console.log("return")

  orderData={flightBooking:[flightDetail,returnDetail],travellerDetails:travellerDetails}
 
  orderData.flightBooking[0].fromAirport=this.returnflight[0].fromAirport
  orderData.flightBooking[0].toAirport=this.returnflight[0].toAirport
  orderData.flightBooking[1].fromAirport=this.returnflight[1].fromAirport
  
  orderData.flightBooking[1].toAirport=this.returnflight[1].toAirport
}



     this.generateOrder(orderData);

// let flightDetail:any={}
// flightDetail={...item}
// if(this.fairbookingDetail){
//   flightDetail.fare=[{...this.fairbookingDetail}]

// }
//  let url= "/app/book?flightBooking="+JSON.stringify(flightDetail)
//  window.open(url);
}
showSpiner:boolean=false
tripResponse:any
getActiveTripList(){
  this.TripService
  .getActiveTrip( this.userUuid)
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
        this.tripResponse={
          tripName:data?.tripName,
          tripUid:data?.tripUid
        }
       
       } else {

       } 
    },error : (err) => {

      console.error("Error in fetching result");
    }
  })}
generateOrder(data:any){
  if(this.userType==='STAFF'){
    let url= "/app/book"
    window.open(url);
  }else if(this.countdown===0){
    this.DialogService.open({msg : "Search session has been expired  need to Re-Search",title : "Confirmation",buttonType : "ref"})
           
    this.DialogService.onResponse((response :  string) => {
     
      if(response=="Search") {
        this.searchFlight()


      }})
  } 
  else{
this.showSpiner=true
data.requestUuid=this.messageData.uuid

    let airSearchRequest=JSON.parse(JSON.stringify(this.messageData))
    delete airSearchRequest.uuid;

    data.airSearchRequest=airSearchRequest
data.channel='WEB'
data.isDomestic=this.domIn.international
data.isInternational=this.domIn.domestic
if(this.tripEnable===true){
    data.tripUid=this.tripResponse?.tripUid
    }
    this.FlightService
    .generateOrder(data)
    .subscribe({
      next : (res:any) => {
        this.showSpiner=false


        if(res) {

         let item:any
         item=res  
        //  console.log(item?.orderNumber)
         let url= "/app/book?id="+this.SettingsService.transform(item?.orderNumber)
         window.open(url);

        } else {    
        } 
      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Unable to book; please try later !",msgTitle:  "Warning", msgType : "W"});

        this.showSpiner=false


      }
    }
  )}
  }
  dateFormate(date:any){
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-US');
    date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

  }

cityFilter(item:any){
  // console.log(item)
  if(item && this.flightDataList){
   
    return this.flightDataList.get(item)?.city;

//     item=this.flightDataList.filter((itm: { iataCode: any; })=>itm.iataCode === item)
//     // console.log(item)

//   item=item[0]?.city

// return item
}else{
  return item
}
}
airPortFilter(item:any){

  if(item && this.flightDataList){
    return this.flightDataList.get(item)?.name;

//   item=this.flightDataList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

// item=item[0]?.name
// return item
}else{
  return item
}
}
fligthNameFilter(item:any){
  
 if(item){
  return this.carrierCode.get(item)?.flightName??item;

    // let flightName:any=[]
//  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
 
//  if(flightName.length===0){
//   return item

// }else{
//   flightName =flightName[0]?.flightName
//   return flightName
// }
 }else{return item}
}
flightlogoFilter(item:any){
  
  if(item){
    //  let flightName:any=[]
     return this.carrierCode.get(item)?.logo??item;

  // flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  
//   if(flightName.length===0){
//    return item
 
//  }else{
//    flightName =flightName[0]?.logo
//    return flightName
//  }
  }else{return item}
 }
ActiveDeparture:any
ActiveReturn:any
ActiveThird:any
ActiveFourth:any
selectFlight(item:any){
item.selected=true
  if(item==this.ActiveDeparture){

 }else{

  this.ActiveDeparture=item
  this.departureFlight={ ...item }
  this.departureFlight.fare=[{...item.fare[0]}]
 
 }
}
selectRFlight(item:any){
  if(item==this.ActiveReturn){


//this.returnFlight.fare=this.returnFlight.fare[0]

}else{
  this.ActiveReturn=item
  this.returnFlight = {...item}
  this.returnFlight.fare=[{...item.fare[0]}]
 
}
}

selectTFlight(item:any){
  if(item==this.ActiveThird){


//this.returnFlight.fare=this.returnFlight.fare[0]

}else{
  this.ActiveThird=item
  this.thirdFlight = {...item}
  this.thirdFlight.fare=[{...item.fare[0]}]
 
}
}
selectFFlight(item:any){
  if(item==this.ActiveFourth){


//this.returnFlight.fare=this.returnFlight.fare[0]

}else{
  this.ActiveFourth=item
  this.fourthFlight = {...item}
  this.fourthFlight.fare=[{...item.fare[0]}]
 
}
}

activeDeparture(item:any){
if(item==this.ActiveDeparture)
{

  return item
}
}
activeReturn(item:any){
  if(item==this.ActiveReturn)
  {
    return item
  }
  }
  activeThird(item:any){
    if(item==this.ActiveThird)
    {
      return item
    }
    }
    activeFourth(item:any){
      if(item==this.ActiveFourth)
      {
        return item
      }
      }
  openPopup(item:any,fare:any) {
   
    let flight:any
    flight={...item}
    
   this.departureFlight=flight
    this.departureFlight.fare=[fare]
    this.flightDetails=false;
  }
  closePopup() {
    this.sharePopup=false
    this.flightDetails=true;
        this.json=  []
        this.rJson=[]
        this.allEmailData=[]
  this.allInboundEmailData=[]
  }




  // add(event: MatChipInputEvent): void {
  //   const value = (event.value || '').trim();

  //   // Add our fruit
  //   if (value) {
  //     this.fruits.push(value);
  //   }

  //   // Clear the input value
  //   event.chipInput!.clear();

  //   this.fruitCtrl.setValue(null);
  // }
  // addTo(event: MatChipInputEvent): void {
  //   const value = (event.value || '').trim();

  //   // Add our fruit
  //   if (value) {
  //     this.wherecity.push(value);
  //   }

  //   // Clear the input value
  //   event.chipInput!.clear();

  //   this.ToCtrl.setValue(null);
  // }

  // remove(fruit: string): void {
  //   const index = this.fruits.indexOf(fruit);

  //   if (index >= 0) {
  //     this.fruits.splice(index, 1);

  //     this.announcer.announce(`Removed ${fruit}`);
  //   }
  // }

  // selected(event: MatAutocompleteSelectedEvent): void {
  //   this.fruits=event.option.viewValue;
  //   this.fromAirportError=false
   
  //   this.fruitInput.nativeElement.value = event.option.viewValue;
  //   this.fruitCtrl.setValue(null);
    
  // }
  // selectedTo(event: MatAutocompleteSelectedEvent): void {
  //   this.wherecity=event.option.viewValue;
  //   this.toAirportError=false

  //   this.ToInput.nativeElement.value = event.option.viewValue;
    

  //   this.ToCtrl.setValue(null);

  // }
  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.allFruits.filter((fruit: any) => fruit.toLowerCase().includes(filterValue));
  // }
  // private _filterTo(value: string): string[] {
  //   const filterValue = value.toLowerCase(); 
  //   return this.whereTo.filter((airport: any) => airport.toLowerCase().includes(filterValue));
  // }

  // private _filter(value: string): string[] {
  //   // Split the input value by comma and take the first part
  //   const filterValue = value.split(',')[0].toLowerCase().trim();
  
  //   // Use the filter method to create a new array containing only the matching fruits
  //   return this.allFruits.filter((fruit: any) => {
  //     // Split each fruit by comma and take the first part
  //     const Content = fruit.split(',')[0].toLowerCase().trim();
  //     const Content1 = fruit.split(',')[1].toLowerCase().trim();

  //     // Check if the lowercase fruit content includes the lowercase filterValue
  //    // return Content.includes(filterValue)||Content1.includes(filterValue);
  //     return Content.includes(filterValue) 

  //   } );
  // }
  // private _filterTo(value: string): string[] {
  //   // Split the input value by comma and take the first part
  //   const filterValue = value.split(',')[0].toLowerCase().trim();
  
  //   // Use the filter method to create a new array containing only the matching fruits
  //   return this.whereTo.filter((fruit: any) => {
  //     // Split each fruit by comma and take the first part
  //     const whereTo = fruit.split(',')[0].toLowerCase().trim();
  //     const whereTo1 = fruit.split(',')[1].toLowerCase().trim();

  //     // Check if the lowercase fruit content includes the lowercase filterValue
  //     return whereTo.includes(filterValue) 
  //   } );
  // }



Tooltip(item:string){
item="hello"
}

increment() {
  if (this.currentNumber < 9) {
    this.currentNumber++;
    this.adult=this.currentNumber+` `+"Adult"

  } }
  cIncrement() {
  if (this.ccurrentNumber < 9) {
    this.ccurrentNumber++;
    this.child=this.ccurrentNumber+` `+"Child"
  }}
  iIncrement() {
  if (this.icurrentNumber < 9) {
    this.icurrentNumber++;
    this.Infants=this.icurrentNumber+` `+"Infants"
  } }

decrement() {
  if (this.currentNumber > 1) {
    this.currentNumber--;
    this.adult=this.currentNumber+` `+"Adult"

  }}
  cDecrement() {
  if (this.ccurrentNumber > 0) {
    this.ccurrentNumber--;
    this.child=this.ccurrentNumber+` `+"Child"

  }}
  iDecrement() {
  if (this.icurrentNumber > 0) {
    this.icurrentNumber--;
    this.Infants=this.icurrentNumber+` `+"Infants"

  }
}
selectItem(item: string) {
  this.selectedItem = item;
}
selectPerson(item: string) {
  this.selectedPerson = item;
}
selectedDetail:boolean=false

SelectDetail(){
  this.selectedDetail=!this.selectedDetail

}

onArrowClick(item:any){
  item=true
 // console.log(item)
}





formatDate(val: Date) {
  let convertedValue:any = ""
  if(val){
  let datepipe = new DatePipe("en");
  //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
  convertedValue =  datepipe.transform(val, "yyyy-MM-dd");
  }
  return convertedValue;
}


onClickDropdown(flightDetail:any){
 //console.log(flightDetail)
  if(this.returnflight[1]){
    for(let i=0;i<this.returnflight[1].flights.length;i++){
      this.returnflight[1].flights[i].dropDown=false
      this.returnflight[1].flights[i].fare.forEach(function(item: any) {item.selected=''})

         
    }}
    flightDetail.fare[0].selected='true'
    flightDetail.selected=true
    flightDetail.dropDown=true
}
onClickDropup(flightDetail:any){

//  console.log(flightDetail)
   if(this.returnflight[1]){
     for(let i=0;i<this.returnflight[1].flights.length;i++){
       this.returnflight[1].flights[i].dropDown=false
 
          
     }}

  //console.log(flightDetail)
  //  if(this.returnflight[1]){
  //    for(let i=0;i<this.returnflight[1].flights.length;i++){
  //      this.returnflight[1].flights[i].dropDown=false
  //      this.returnflight[1].flights[i].fare.forEach(function(item: any) {item.selected=''})
 
          
  //    }}
     
 
 }

 onClickTDropdown(flightDetail:any){
  //console.log(flightDetail)
   if(this.returnflight[2]){
     for(let i=0;i<this.returnflight[2].flights.length;i++){
       this.returnflight[2].flights[i].dropDown=false
       this.returnflight[2].flights[i].fare.forEach(function(item: any) {item.selected=''})
 
          
     }}
     flightDetail.fare[0].selected='true'
     flightDetail.selected=true
     flightDetail.dropDown=true
 }
 onClickTDropup(flightDetail:any){
 
 //  console.log(flightDetail)
    if(this.returnflight[2]){
      for(let i=0;i<this.returnflight[2].flights.length;i++){
        this.returnflight[2].flights[i].dropDown=false
  
           
      }}
 
   //console.log(flightDetail)
   //  if(this.returnflight[1]){
   //    for(let i=0;i<this.returnflight[1].flights.length;i++){
   //      this.returnflight[1].flights[i].dropDown=false
   //      this.returnflight[1].flights[i].fare.forEach(function(item: any) {item.selected=''})
  
           
   //    }}
      
  
  }
 
  onClickFDropdown(flightDetail:any){
    //console.log(flightDetail)
     if(this.returnflight[3]){
       for(let i=0;i<this.returnflight[3].flights.length;i++){
         this.returnflight[3].flights[i].dropDown=false
         this.returnflight[3].flights[i].fare.forEach(function(item: any) {item.selected=''})
   
            
       }}
       flightDetail.fare[0].selected='true'
       flightDetail.selected=true
       flightDetail.dropDown=true
   }
   onClickFDropup(flightDetail:any){
   
   //  console.log(flightDetail)
      if(this.returnflight[3]){
        for(let i=0;i<this.returnflight[3].flights.length;i++){
          this.returnflight[3].flights[i].dropDown=false
    
             
        }}
   
     //console.log(flightDetail)
     //  if(this.returnflight[1]){
     //    for(let i=0;i<this.returnflight[1].flights.length;i++){
     //      this.returnflight[1].flights[i].dropDown=false
     //      this.returnflight[1].flights[i].fare.forEach(function(item: any) {item.selected=''})
    
             
     //    }}
        
    
    }


 onClickDepartureDown(flightDetail:any){

  //console.log(flightDetail)
   if(this.returnflight[0]){
     for(let i=0;i<this.returnflight[0].flights.length;i++){
       this.returnflight[0].flights[i].dropDown=false
       this.returnflight[0].flights[i].selected=false
       //flightDetail[0].flights[i].selected=false
       this.returnflight[0].flights[i].fare.forEach(function(item: any) {item.selected=''})
       this.returnflight[0].flights[i].fare.forEach((item: any, index: number) => {
              item.number = index;
            });
     }}
     flightDetail.fare[0].selected='true'

    
     flightDetail.selected=true

    
     flightDetail.dropDown=true
 }
 onClickDepartureUp(flightDetail:any){

   if(this.returnflight[0]){
     for(let i=0;i<this.returnflight[0].flights.length;i++){
       this.returnflight[0].flights[i].dropDown=false
      
      
     }}
  //console.log(flightDetail)
  //  if(this.returnflight[0]){
  //    for(let i=0;i<this.returnflight[0].flights.length;i++){
  //      this.returnflight[0].flights[i].dropDown=false
  //      this.returnflight[0].flights[i].selected=false
  //      //flightDetail[0].flights[i].selected=false
  //      this.returnflight[0].flights[i].fare.forEach(function(item: any) {item.selected=''})
  //      this.returnflight[0].flights[i].fare.forEach((item: any, index: number) => {
  //       item.number = index;
  //     });
      
  //    }}
     

    
 }
 passengerTypeMapping(item:any){
    let type:any=[]
    
        if(item){

      //  console.log(item)
const typePassenger=item
if(typePassenger)
{
  type =typePassenger.filter((typeItem:any)=>typeItem.fareDetailsPerPassengerType.passengerType==="ADT")
}
//console.log(type)
return type
}else{
  return []

}
      
    
 }
 passengerCTypeMapping(item:any){

  let type:any=[]
  
      if(item){

     
const typePassenger=item
if(typePassenger)
{
type =typePassenger.filter((typeItem:any)=>typeItem.fareDetailsPerPassengerType.passengerType==="CH"||typeItem.fareDetailsPerPassengerType.passengerType==="CHD"||typeItem.fareDetailsPerPassengerType.passengerType==="CNN")
}
//console.log(type)
return type
}else{
return []

}
    
  
}
passengerITypeMapping(item:any){
  
  let type:any=[]
  
      if(item){

     
const typePassenger=item
if(typePassenger)
{
type =typePassenger.filter((typeItem:any)=>typeItem.fareDetailsPerPassengerType.passengerType==="INF"||typeItem.fareDetailsPerPassengerType.passengerType==="IN")
}
//console.log(type)
return type
}else{
return []

}
    
  
}
fareMapping(fare:any,item: any,fareiItem:any) {
  if (fare?.fareType== item.fare[1]?.fareType ) {
    let type: any[] = [];

    if (item?.flightDetailsList) {
      // for (let i = 0; i < item.flightDetailsList.length; i++) {
        const bookingClasses = item.flightDetailsList[0]?.bookingClasses;

        if (bookingClasses) {
          type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareType === fare?.fareType&&bookingItem?.corporateFare===fare?.corporateFare);
        }
      // }
    }
return type
    // You might want to return something here based on your requirements
    // return type?.fareDetailsPerPassengerType?.taxes;
  } else {
    return []
    // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
    // return '';
  }
}
fareOMapping(fare:any,item: any,fareiItem:any) {
  if (fare?.fareType== fare?.fareType ) {
    let type: any[] = [];

    if (item?.flightDetailsList) {
      // for (let i = 0; i < item.flightDetailsList.length; i++) {
        const bookingClasses = item.flightDetailsList[0]?.bookingClasses;

        if (bookingClasses) {
          type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareType === fare?.fareType&&bookingItem?.corporateFare===fare?.corporateFare);
        }
      // }
    }
return type
    // You might want to return something here based on your requirements
    // return type?.fareDetailsPerPassengerType?.taxes;
  } else {
    return []
    // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
    // return '';
  }
}

 fareTypeMapping(item: any) {
  if (item?.fare && item.fare[0]?.fareType) {
    // console.log(item)
    let type: any[] = [];

    if (item?.flightDetailsList) {
      // for (let i = 0; i < item.flightDetailsList.length; i++) {
        const bookingClasses = item.flightDetailsList[0]?.bookingClasses;

        if (bookingClasses) {
          type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareType === item.fare[0]?.fareType&&bookingItem?.corporateFare===item.fare[0]?.corporateFare);
        }
      // }
    }
return type
    // You might want to return something here based on your requirements
    // return type?.fareDetailsPerPassengerType?.taxes;
  } else {
    return []
    // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
    // return '';
  }
}

 getObjectKeysAndValues(obj: any): { key: string, value: any }[] {
  // console.log(this.departureFlight)
  // let flight:any=this.departureFlight
 
  
  if(obj){

    let object:any=[]
     object=Object.entries(obj).map(([key, value]) => ({ key, value }));
   for (let i =0;i<object.length;i++){
  //console.log(object[i].value)

  object[i].value=(object[i]?.value?.join(','))


}
  return object;
 }else{
  return obj
 }
}
areDatesEqual(date1: Date, date2: Date): boolean {
  // Compare year, month, and day to check if the dates are equal
  return date1.getFullYear() === date2.getFullYear() &&
         date1.getMonth() === date2.getMonth() &&
         date1.getDate() === date2.getDate();
}





getObjectKeysAndValue(obj: any): { key: string, value: any }[] {
  // console.log(this.departureFlight)
  // let flight:any=this.departureFlight
 
  if(obj){


    let object:any=[]
     object=Object.entries(obj).map(([key, value]) => ({ key, value }));
  //    let hiddenKeys: any="bookingAmount,currency"
  // object=object.filter((item:any)=>!hiddenKeys.includes(item.key))

 
  return object;
 }else{
  return obj
 }
}

showDialog:boolean=false
showAirDialog:boolean=false
showTimeDialog:boolean=false
OpenDialog(){
  this.showDialog=true
}

closeDialog(){
  this.showDialog=false
  this.showAirDialog=false
this.showTimeDialog=false
}
OpenAirDialog(){
this.showAirDialog=true
}
OpenTimeDialog(){
  this.showTimeDialog=true


}
sortByAsc:boolean=true
sortByPrice(): void {
  if (this.sortByAsc) {
    this.flightDetail.sort((a:any, b:any) => {
      const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      return priceA - priceB;
    });
  } else {
    this.flightDetail.sort((a:any, b:any) => {
      const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      return priceB - priceA;
    });
  }
  if(this.returnFlightDetail){
  if (this.sortByAsc ) {
    this.returnFlightDetail.sort((a:any, b:any) => {
      const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      return priceA - priceB;
    });
  } else {
    this.returnFlightDetail.sort((a:any, b:any) => {
      const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      return priceB - priceA;
    });
  }}
/* ++++++++++++++++third++++++++++++++*/ 
  if(this.thirdFlightDetail){
    if (this.sortByAsc ) {
      this.thirdFlightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceA - priceB;
      });
    } else {
      this.thirdFlightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceB - priceA;
      });
    }}
/* ++++++++++++++++fourth++++++++++++++*/ 

if(this.fourthFlightDetail){
  if (this.sortByAsc ) {
    this.fourthFlightDetail.sort((a:any, b:any) => {
      const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      return priceA - priceB;
    });
  } else {
    this.fourthFlightDetail.sort((a:any, b:any) => {
      const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
      return priceB - priceA;
    });
  }}
  this.sortByAsc = !this.sortByAsc; // Toggle sorting order
}
// <button (click)="sortByPrice()">Sort by Price</button>
// <input type="number" placeholder="Enter min base fare" [(ngModel)]="minBaseFare">
// <button (click)="filterByBaseFare(minBaseFare)">Filter by Base Fare</button>
minBaseFare:any
// filterByBaseFare(): void {
//   this.flightDetail = this.returnflight[0].flights.filter((flight:any) => flight.fare.some((f:any) => f.baseFare+f.finalTax+f?.commercialData?.finalAmount >= this.value));

//   if( this.returnFlightDetail ){
//     this.returnFlightDetail = this.returnflight[1].flights.filter((flight:any) => flight.fare.some((f:any) => f.baseFare+f.finalTax+f?.commercialData?.finalAmount >= this.value));

//   }
// }

minPrice:any
minPriceR:any
minPriceT:any
minPriceF:any

maxPrice:any
maxPriceR:any
maxPriceT:any
maxPriceF:any

value:any
valueR:any
valueT:any
valueF:any

calculateMinMaxPrices(): void {
  // const prices = this.flightDetail.map((flight:any) =>
  //   flight.fare.reduce((acc:any, curr:any) =>curr.baseFare+curr.finelTax, 0)
  // );
  let prices:any=[]
  let pricesR:any=[]
  let pricesT:any=[]
  let pricesF:any=[]

  this.flightDetail.forEach((flight:any) =>
  flight.fare.forEach(( curr:any) =>{
    prices.push(curr?.baseFare+curr?.finalTax+curr?.commercialData?.finalAmount)
  })
);
if( this.returnFlightDetail ){
  this.returnFlightDetail.forEach((flight:any) =>
  flight.fare.forEach(( curr:any) =>{
    pricesR.push(curr.baseFare+curr.finalTax+curr?.commercialData?.finalAmount)
  })
);
}
if( this.thirdFlightDetail ){
  this.thirdFlightDetail.forEach((flight:any) =>
  flight.fare.forEach(( curr:any) =>{
    pricesT.push(curr.baseFare+curr.finalTax+curr?.commercialData?.finalAmount)
  })
);
}
if( this.fourthFlightDetail ){
  this.fourthFlightDetail.forEach((flight:any) =>
  flight.fare.forEach(( curr:any) =>{
    pricesF.push(curr.baseFare+curr.finalTax+curr?.commercialData?.finalAmount)
  })
);
}
   this.minPrice = Math.min(...prices);
   this.maxPrice = Math.max(...prices);

   this.minPriceR = Math.min(...pricesR);
   this.maxPriceR = Math.max(...pricesR);

   this.minPriceT = Math.min(...pricesT);
   this.maxPriceT = Math.max(...pricesT);

   this.minPriceF = Math.min(...pricesF);
   this.maxPriceF = Math.max(...pricesF);

  // console.log(this.minPrice)
  // console.log(this.maxPrice)

}
formatLabel(value: number): string {
  if (value >= 1000) {
    return Math.round(value / 1000) + 'k';
  }

  return `${value}`;
}

onMenuClick(event: any) {
  event.preventDefault();
  event.stopPropagation();
  

}
fareRuleMapping(item: any) {
  if (item?.fare && item.fare[0]?.fareTypeDisplay) {
    let type: any[] = [];

    if (item?.flightDetailsList) {
      for (let i = 0; i < item.flightDetailsList.length; i++) {
        const bookingClasses = item.flightDetailsList[i]?.bookingClasses;

        if (bookingClasses) {
          type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareTypeDisplay === item.fare[0]?.fareTypeDisplay&&bookingItem?.corporateFare === item.fare[0]?.corporateFare);
        }
      }
    }
return type
    // You might want to return something here based on your requirements
    // return type?.fareDetailsPerPassengerType?.taxes;
  } else {
    return []
    // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
    // return '';
  }
}
getFareRules(){
  let rule=  {"fareRules": 'pending'}
  this.farejson=  rule
  var selectedFlight=JSON.parse(JSON.stringify(this.departureFlight));

for(let i=0;i< selectedFlight.flightDetailsList.length;i++){
  selectedFlight.flightDetailsList[i].bookingClasses= this.fareRuleMapping(selectedFlight)
}
  let request:any={
    "paxCount": this.messageData?.paxCount,
    "adultCount": this.messageData?.adultCount,
    "childCount": this.messageData?.childCount,
    "infantCount": this.messageData?.infantCount,
    "selectedFlight": [
        {
            "fromAirport": this.messageData?.airSearchRequestBaseDetails[0]?.fromAirport,
            "toAirport": this.messageData?.airSearchRequestBaseDetails[0]?.toAirport,
            "source": selectedFlight?.source,
             "flightDetailsList":selectedFlight?.flightDetailsList,
        "routeRequest":selectedFlight?.routeRequest
        }
    ]
}

  this.FlightService
  .getFareRules(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data:any
       data=res
      //  console.log(data)
       let rule=  data
       this.farejson=  rule
       this.convertJson( this.farejson)

      //  this.json=this.convertJson()
      } else {  
        let rule=  {"fareRules": null}
        this.farejson=  rule
        this.convertJson( this.farejson)

      } 

    },error : (err) => {
      let rule=  {"fareRules": null}
      this.farejson=  rule
      this.convertJson( this.farejson)


    }
  }
)

}

farejson:any={}
json:any=[]

fareRjson:any={}
fareTjson:any={}
fareFjson:any={}

rJson:any=[]
tJson:any=[]
fJson:any=[]

convertJson(item:any){
  let data:any=[]
  // console.log(item?.fareRules)
  data=this.getObjectKeysAndValue(item?.fareRules)
  // console.log(data)
   this.json= data
 
}


getFFareRules(){
  if(this.fourthFlight){
  let rule=  {"fareRules": 'pending'}
  this.fareRjson=  rule
    var selectedFlight=JSON.parse(JSON.stringify(this.fourthFlight));

for(let i=0;i< selectedFlight.flightDetailsList.length;i++){
  selectedFlight.flightDetailsList[i].bookingClasses= this.fareRuleMapping(selectedFlight)
}
  let request:any={
    "paxCount": this.messageData?.paxCount,
    "adultCount": this.messageData?.adultCount,
    "childCount": this.messageData?.childCount,
    "infantCount": this.messageData?.infantCount,
    "selectedFlight": [
        {
            "fromAirport":this.messageData?.airSearchRequestBaseDetails[0]?.toAirport,
            "toAirport":  this.messageData?.airSearchRequestBaseDetails[0]?.fromAirport,
            "source": selectedFlight?.source,
             "flightDetailsList":selectedFlight.flightDetailsList,
             "routeRequest":selectedFlight?.routeRequest
        }
    ]
}

  this.FlightService
  .getFareRules(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data:any
       data=res
      //  console.log(data)
       let rule=  data
       this.fareFjson=  rule
        this.convertFJson( this.fareFjson)

      //  this.json=this.convertJson()
      } else {  
        let rule=  {"fareRules": null}
        this.fareFjson=  rule
        this.convertFJson( this.fareFjson)

      } 

    },error : (err) => {
      let rule=  {"fareRules": null}
      this.fareFjson=  rule
      this.convertFJson( this.fareFjson)


    }
  }
)
}
}
convertFJson(item:any){
  let data:any=[]
  data=this.getObjectKeysAndValue(item?.fareRules)
   this.fJson= data

}




getTFareRules(){
  if(this.thirdFlight){
  let rule=  {"fareRules": 'pending'}
  this.fareRjson=  rule
    var selectedFlight=JSON.parse(JSON.stringify(this.thirdFlight));

for(let i=0;i< selectedFlight.flightDetailsList.length;i++){
  selectedFlight.flightDetailsList[i].bookingClasses= this.fareRuleMapping(selectedFlight)
}
  let request:any={
    "paxCount": this.messageData?.paxCount,
    "adultCount": this.messageData?.adultCount,
    "childCount": this.messageData?.childCount,
    "infantCount": this.messageData?.infantCount,
    "selectedFlight": [
        {
            "fromAirport":this.messageData?.airSearchRequestBaseDetails[0]?.toAirport,
            "toAirport":  this.messageData?.airSearchRequestBaseDetails[0]?.fromAirport,
            "source": selectedFlight?.source,
             "flightDetailsList":selectedFlight.flightDetailsList,
             "routeRequest":selectedFlight?.routeRequest
        }
    ]
}

  this.FlightService
  .getFareRules(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data:any
       data=res
      //  console.log(data)
       let rule=  data
       this.fareTjson=  rule
        this.convertTJson( this.fareTjson)

      //  this.json=this.convertJson()
      } else {  
        let rule=  {"fareRules": null}
        this.fareTjson=  rule
        this.convertTJson( this.fareTjson)

      } 

    },error : (err) => {
      let rule=  {"fareRules": null}
      this.fareTjson=  rule
      this.convertTJson( this.fareTjson)


    }
  }
)
  }
}
convertTJson(item:any){
  let data:any=[]
  data=this.getObjectKeysAndValue(item?.fareRules)
   this.tJson= data

}
getRFareRules(){
  let rule=  {"fareRules": 'pending'}
  this.fareRjson=  rule
    var selectedFlight=JSON.parse(JSON.stringify(this.returnFlight));

for(let i=0;i< selectedFlight.flightDetailsList.length;i++){
  selectedFlight.flightDetailsList[i].bookingClasses= this.fareRuleMapping(selectedFlight)
}
  let request:any={
    "paxCount": this.messageData?.paxCount,
    "adultCount": this.messageData?.adultCount,
    "childCount": this.messageData?.childCount,
    "infantCount": this.messageData?.infantCount,
    "selectedFlight": [
        {
            "fromAirport":this.messageData?.airSearchRequestBaseDetails[0]?.toAirport,
            "toAirport":  this.messageData?.airSearchRequestBaseDetails[0]?.fromAirport,
            "source": selectedFlight?.source,
             "flightDetailsList":selectedFlight.flightDetailsList,
             "routeRequest":selectedFlight?.routeRequest
        }
    ]
}

  this.FlightService
  .getFareRules(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data:any
       data=res
      //  console.log(data)
       let rule=  data
       this.fareRjson=  rule
        this.convertRJson( this.fareRjson)

      //  this.json=this.convertJson()
      } else {  
        let rule=  {"fareRules": null}
        this.fareRjson=  rule
        this.convertRJson( this.fareRjson)

      } 

    },error : (err) => {
      let rule=  {"fareRules": null}
      this.fareRjson=  rule
      this.convertRJson( this.fareRjson)


    }
  }
)

}

convertRJson(item:any){
  let data:any=[]
  data=this.getObjectKeysAndValue(item?.fareRules)
   this.rJson= data

}


enableCheck:boolean=false
enableCheckBox(){
  if( this.enableCheck===true){
    for(let i=0;i<this.returnflight[0].flights.length;i++){
       this.returnflight[0].flights[i].dropDown=true
       this.returnflight[0].flights[i].selected=true

    }
    if(this.returnflight[1].flights){
    for(let i=0;i<this.returnflight[1].flights.length;i++){
      this.returnflight[1].flights[i].dropDown=true
      this.returnflight[1].flights[i].selected=true

   }}
   if(this.returnflight&&this.returnflight.length===3&&this.returnflight[2].flights){
    for(let i=0;i<this.returnflight[2].flights.length;i++){
      this.returnflight[2].flights[i].dropDown=true
      this.returnflight[2].flights[i].selected=true

   }}
   if(this.returnflight&&this.returnflight.length===4&&this.returnflight[3].flights){
    for(let i=0;i<this.returnflight[3].flights.length;i++){
      this.returnflight[3].flights[i].dropDown=true
      this.returnflight[3].flights[i].selected=true

   }}
  }else{
    this.SelectedEmailData=[]
this.allEmailData=[]
  this.allInboundEmailData=[]
    for(let i=0;i<this.returnflight[0].flights.length;i++){
      this.returnflight[0].flights[i].dropDown=false
      this.returnflight[0].flights[i].selected=false

    }
    if(this.returnflight.length>1){
    if(this.returnflight[1].flights){
      for(let i=0;i<this.returnflight[1].flights.length;i++){
        this.returnflight[1].flights[i].dropDown=false
        this.returnflight[1].flights[i].selected=false

      }
    }}
    if(this.returnflight.length>2){
    if(this.returnflight[2].flights){
      for(let i=0;i<this.returnflight[2].flights.length;i++){
        this.returnflight[2].flights[i].dropDown=false
        this.returnflight[2].flights[i].selected=false

      }
    }}
    if(this.returnflight.length>3){

   
    if(this.returnflight[3].flights){
      for(let i=0;i<this.returnflight[3].flights.length;i++){
        this.returnflight[3].flights[i].dropDown=false
        this.returnflight[3].flights[i].selected=false

      }
    }
  }
   
  }
}
shareEmailPopup(){
  this.closeviewData()

this.sharePopup=true
}
@ViewChild('travellerInput') travellerInput!: ElementRef<HTMLInputElement>;
traveller = new FormControl('');
filteredTo!: Observable<any[]>;
travellerTo:any=[]
travellerName:any
usersList:any;
employeeData:any



getCorporateUsers(){
   
  this.UserprofileService
  .getUserList()
  .subscribe({
    next : (res:any) => {
      if(res) {
       
       let data:any
       data=res  
       this.usersList=data
      // console.log(this.usersList)
      this.usersList=this.usersList.filter((item:any) => item.firstName && item.firstName.trim() !== '');
       this.travellerTo=this.usersList
       this.filteredTo = this.traveller.valueChanges.pipe(
        // debounceTime(300), // Adjust the debounce time as needed
        //distinctUntilChanged(),
        startWith(null),
        map((item: any | null) => (item ? this._filter(item) : this.travellerTo.slice())),
      );
      // console.log(this.usersList)

      } else {    
      } 
    },error : (err) => {

      
    }
  }
)
}
private _filter(value: any): any[] {
  // console.log(value)
   const filterValue = value.toLowerCase();
  
   return this.travellerTo.filter((item:any) => item.username.toLowerCase().includes(filterValue));
 }
 addTo(event: MatChipInputEvent): void {
  const value = (event.value || '').trim();

  // Add our fruit
  if (value) {
    this.travellerName.push(value);
  }

  // Clear the input value
  event.chipInput!.clear();

  this.traveller.setValue(null);
}


onfilterChange(passengerDetails:any){

  for(let i=0;i<passengerDetails?.length;i++){
    
  // console.log(passengerDetails[i]?.username)
  let data:any
  data=this.travellerTo.filter((item:any) => item.username===passengerDetails[i]?.username)
  // console.log(data)
  

}
}
onfilterClick(value:any){

  // this.travellerInput.nativeElement.value=''
this.travellerEmail=value
this.travellerCCEmail=value

 for(let i=0;i<3;i++){

   
  let data:any
  data=this.travellerTo.filter((item:any) => item.username===value)
  

//  this.passengerDetails.controls[0].value.firstName=data[0]?.firstName

//   this.passengerDetails.controls[0].value.lastName=data[0]?.lastName
//   this.passengerDetails.controls[0].value.passengerTitle=data[0]?.title
  

 }
 }

selectedTo(event: MatAutocompleteSelectedEvent): void {

  this.travellerName=event.option.viewValue;

  this.travellerInput.nativeElement.value = event.option.viewValue;

  
   
  this.traveller.setValue(null);

}
getEmployeeData(){

  this.UserprofileService
  .getEmployeeUser()
  .subscribe({
    next : (res:any) => {
      if(res) {

       let data:any
       data=res  
       this.employeeData=data
      

      

      } else {    
        
      } 
    },error : (err) => {

      
    }
  }

)

}
travellerCCEmail:any
travellerEmail:any
addCC:any=[]
addTO:any=[]
addT:any=[]
addC:any=[]

onClickTo(){
 if(    this.travellerEmail===''){
 }else{
  if (!this.addT.includes(this.travellerEmail)) {
    this.addT.push(this.travellerEmail);
  } else {
    console.log('Duplicate value found:', this.travellerEmail);
  }
 
if(this.addT.length===0){
}else{
  this.addTO=  this.addT.join(',')
}
// this.travellerInput.nativeElement.value=''
    this.travellerEmail=''
}
}
onClickCC(){
  if(    this.travellerCCEmail===''){
  }else{
   if (!this.addC.includes(this.travellerCCEmail)) {
     this.addC.push(this.travellerCCEmail);
   } else {
    //  console.log('Duplicate value found:', this.travellerCCEmail);
   }
  
 if(this.addC.length===0){
 }else{
   this.addCC=  this.addC.join(',')
 
 }
 // this.travellerInput.nativeElement.value=''
     this.travellerCCEmail=''
 }
 }
 fetchAllData:boolean=false
 sendAllData(){
  this.SelectedView=false
this.closeviewData()
  this.sharePopup=true
this.fetchAllData=true 
this.allEmailData=[]
this.allInboundEmailData=[]



}

sendSelectedData(){
  this.closeviewData()

  this.SelectedView=true
  // this.viewData=true
  this.sharePopup=true
  // this.fetchAllData=true
  this.fetchAllData=true 
  this.allEmailData=[]
  this.allInboundEmailData=[]
  this.allInboundTEmailData=[]
this.allInboundFEmailData=[]
  this.allEmailData=JSON.parse(JSON.stringify(this.SelectedEmailData))
  for(let i=0;i<this.allEmailData.length;i++){
    this.allEmailData[i]=`Option ${1+i} \n`+ this.allEmailData[i]+'\n'
    
  }
  
  this.allEmailData=this.allEmailData.join('')

  this.allEmailData=`Outbound \n`+ this.allEmailData

  // this.allInboundEmailData=this.allInboundEmailData.join('')

  if(this.returnflight[1]?.flights){
    this.allInboundEmailData= JSON.parse(JSON.stringify(this.SelectedInboundEmailData))

    for(let i=0;i<this.allInboundEmailData.length;i++){
      this.allInboundEmailData[i]=`Option ${1+i} \n`+ this.allInboundEmailData[i]+'\n'
      
    }
    
    this.allInboundEmailData=this.allInboundEmailData.join('')
  
    this.allInboundEmailData=`Inbound \n`+ this.allInboundEmailData

}
if(this.returnflight[2]?.flights){
  this.allInboundTEmailData= JSON.parse(JSON.stringify(this.SelectedTInboundEmailData))

  for(let i=0;i<this.allInboundTEmailData.length;i++){
    this.allInboundTEmailData[i]=`Option ${1+i} \n`+ this.allInboundTEmailData[i]+'\n'
    
  }
  
  this.allInboundTEmailData=this.allInboundTEmailData.join('')

  this.allInboundTEmailData=` \n`+ this.allInboundTEmailData

}
if(this.returnflight[3]?.flights){
  this.allInboundFEmailData= JSON.parse(JSON.stringify(this.SelectedFInboundEmailData))

  for(let i=0;i<this.allInboundFEmailData.length;i++){
    this.allInboundFEmailData[i]=`Option ${1+i} \n`+ this.allInboundFEmailData[i]+'\n'
    
  }
  
  this.allInboundFEmailData=this.allInboundFEmailData.join('')

  this.allInboundFEmailData=` \n`+ this.allInboundFEmailData

}


}

onClickView(){
this.viewData=true
this.allEmailData=[]
this.allInboundEmailData=[]
this.allInboundTEmailData=[]
this.allInboundFEmailData=[]
// console.log(this.returnflight[0].flights)

  for(let flight of this.returnflight[0].flights){
    for(let fare of flight?.fare){
      // `${flight?.flightDetailsList[0]?.carrierName}${ flight?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[0]?.fromAirport }${ this.returnflight[0]?.toAirport } ${ this.dateFormatMMM(flight?.schDepartureTime)} ${ this.dateFormatHH(flight?.schDepartureTime) } ${this.dateFormatHH( flight?.schArrivalTime) }`+'\n'
     this.allEmailData.push(this.shareFilter(flight?.flightDetailsList)+
     `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
     `Fare Type: ${ fare?.fareTypeDisplay }`+'\n')
    }
  }

for(let i=0;i<this.allEmailData.length;i++){
  this.allEmailData[i]=`Option ${1+i} \n`+ this.allEmailData[i]+'\n'

}
  this.allEmailData=this.allEmailData.join('')


this.allEmailData=`Outbound \n`+ this.allEmailData

if(this.returnflight[1]?.flights){
    for(let flight of this.returnflight[1].flights){
      for(let fare of flight?.fare){
        // `${flight?.flightDetailsList[0]?.carrierName}${ flight?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(flight?.schDepartureTime)} ${ this.dateFormatHH(flight?.schDepartureTime) } ${this.dateFormatHH( flight?.schArrivalTime) }`+'\n'
       this.allInboundEmailData.push(this.shareFilter(flight?.flightDetailsList)+
       `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
       `Fare Type: ${ fare?.fareTypeDisplay }`+'\n')
      }
    }
  
  for(let i=0;i<this.allInboundEmailData.length;i++){
    this.allInboundEmailData[i]=`Option ${1+i} \n`+ this.allInboundEmailData[i]+'\n'
  

}
  this.allInboundEmailData=this.allInboundEmailData.join('')


this.allInboundEmailData=`Inbound \n`+ this.allInboundEmailData





}

if(this.returnflight[2]?.flights){
  for(let flight of this.returnflight[2].flights){
    for(let fare of flight?.fare){
      // `${flight?.flightDetailsList[0]?.carrierName}${ flight?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(flight?.schDepartureTime)} ${ this.dateFormatHH(flight?.schDepartureTime) } ${this.dateFormatHH( flight?.schArrivalTime) }`+'\n'
     this.allInboundTEmailData.push(this.shareFilter(flight?.flightDetailsList)+
     `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
     `Fare Type: ${ fare?.fareTypeDisplay }`+'\n')
    }
  }

for(let i=0;i<this.allInboundTEmailData.length;i++){
  this.allInboundTEmailData[i]=`Option ${1+i} \n`+ this.allInboundTEmailData[i]+'\n'


}
this.allInboundTEmailData=this.allInboundTEmailData.join('')


this.allInboundTEmailData=` \n`+ this.allInboundTEmailData





}
if(this.returnflight[3]?.flights){
  for(let flight of this.returnflight[3].flights){
    for(let fare of flight?.fare){
      // `${flight?.flightDetailsList[0]?.carrierName}${ flight?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(flight?.schDepartureTime)} ${ this.dateFormatHH(flight?.schDepartureTime) } ${this.dateFormatHH( flight?.schArrivalTime) }`+'\n'
     this.allInboundFEmailData.push(this.shareFilter(flight?.flightDetailsList)+
     `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
     `Fare Type: ${ fare?.fareTypeDisplay }`+'\n')
    }
  }

for(let i=0;i<this.allInboundFEmailData.length;i++){
  this.allInboundFEmailData[i]=`Option ${1+i} \n`+ this.allInboundFEmailData[i]+'\n'


}
this.allInboundFEmailData=this.allInboundFEmailData.join('')


this.allInboundFEmailData=` \n`+ this.allInboundFEmailData





}

}
onSelectedkView(){
  this.SelectedView=true
  this.viewData=true
  

}
viewText:any='view'

onClickTitle(item:any){
this.viewText=item

}
dateFormatMMM(date:any){
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-US');
  date = datePipe.transform(parsedDate, 'dd MMM');
return date

}
dateFormatHH(date:any){
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-US');
  date = datePipe.transform(parsedDate, 'HHmm');
return date

}
closeviewData(){
  this.viewData=false
  }
  sendEmailApiData:any=[]
  shareFilter(item:any){
    console.log()
    let data:any=''
    item.forEach((flightDetailsList:any)=>{
      data += `${flightDetailsList?.carrierName}${flightDetailsList?.flightNumber} ${flightDetailsList?.fromAirport}${flightDetailsList?.fromTerminal?('_T-'+flightDetailsList?.fromTerminal):''} ${flightDetailsList?.toAirport}${flightDetailsList?.toTerminal?('_T-'+flightDetailsList?.toTerminal):''} ${this.dateFormatMMM(flightDetailsList?.schDepartureTime)} ${this.dateFormatHH(flightDetailsList?.schDepartureTime)} ${this.dateFormatHH(flightDetailsList?.schArrivalTime)}` + '\n'

  // data+=`${flightDetailsList?.carrierName}${flightDetailsList?.flightNumber} ${ flightDetailsList?.fromAirport }${ flightDetailsList?.toAirport } ${ this.dateFormatMMM(flightDetailsList?.schDepartureTime)} ${ this.dateFormatHH(flightDetailsList?.schDepartureTime) } ${this.dateFormatHH( flightDetailsList?.schArrivalTime) }`+'\n'
})
    return data
  }


selectShareData(event:any,item:any,fare:any){
if(event.checked){

  let emaiapi:any={...item}
  emaiapi.fare=[fare]
this.sendEmailApiData.push(emaiapi)
// `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[0]?.fromAirport }${ this.returnflight[0]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
     this.SelectedEmailData.push(this.shareFilter(item?.flightDetailsList)+
     `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
     `Fare Type: ${ fare?.fareTypeDisplay }`+'\n')
    
} else{
  // `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[0]?.fromAirport }${ this.returnflight[0]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
  let detail=this.shareFilter(item?.flightDetailsList)+
  `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
  `Fare Type: ${ fare?.fareTypeDisplay }`+'\n'
  let emaiapi:any={...item}
  emaiapi.fare=[fare]
  this.SelectedEmailData=this.SelectedEmailData.filter((items:any)=>items!==detail)
  this.sendEmailApiData=this.sendEmailApiData.filter((items:any)=>items.source!==emaiapi.source||items.travelDuration!==emaiapi.travelDuration||items.fare[0].fareType!==emaiapi.fare[0].fareType||items.fare[0].baseFare!==emaiapi.fare[0].baseFare||items.fare[0].fareTypeDisplay!==emaiapi.fare[0].fareTypeDisplay||items.fare[0].finalTax!==emaiapi.fare[0].finalTax||items.flightDetailsList[0].fromAirport!==emaiapi.flightDetailsList[0].fromAirport||items.flightDetailsList[0].toAirport!==emaiapi.flightDetailsList[0].toAirport||items.flightDetailsList[0].schArrivalTime!==emaiapi.flightDetailsList[0].schArrivalTime||items.flightDetailsList[0].schDepartureTime!==emaiapi.flightDetailsList[0].schDepartureTime)

}


}
selectRShareData(event:any,item:any,fare:any){
if(event.checked){
  let emaiapi:any={...item}
  emaiapi.fare=[fare]
this.sendEmailApiData.push(emaiapi)
// `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
     this.SelectedInboundEmailData.push(this.shareFilter(item?.flightDetailsList)+
     `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
     `Fare Type: ${ fare?.fareTypeDisplay }`+'\n')
    
} else{
  // `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
  let detail=this.shareFilter(item?.flightDetailsList)+
  `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
  `Fare Type: ${ fare?.fareTypeDisplay }`+'\n'
  this.SelectedInboundEmailData=this.SelectedInboundEmailData.filter((items:any)=>items!==detail)
  let emaiapi:any={...item}
  emaiapi.fare=[fare]
  this.sendEmailApiData=this.sendEmailApiData.filter((items:any)=>items.source!==emaiapi.source||items.travelDuration!==emaiapi.travelDuration||items.fare[0].fareType!==emaiapi.fare[0].fareType||items.fare[0].baseFare!==emaiapi.fare[0].baseFare||items.fare[0].fareTypeDisplay!==emaiapi.fare[0].fareTypeDisplay||items.fare[0].finalTax!==emaiapi.fare[0].finalTax||items.flightDetailsList[0].fromAirport!==emaiapi.flightDetailsList[0].fromAirport||items.flightDetailsList[0].toAirport!==emaiapi.flightDetailsList[0].toAirport||items.flightDetailsList[0].schArrivalTime!==emaiapi.flightDetailsList[0].schArrivalTime||items.flightDetailsList[0].schDepartureTime!==emaiapi.flightDetailsList[0].schDepartureTime)

}
}
selectTShareData(event:any,item:any,fare:any){
  if(event.checked){
    let emaiapi:any={...item}
    emaiapi.fare=[fare]
  this.sendEmailApiData.push(emaiapi)
  // `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
       this.SelectedTInboundEmailData.push(this.shareFilter(item?.flightDetailsList)+
       `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
       `Fare Type: ${ fare?.fareTypeDisplay }`+'\n')
      
  } else{
    // `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
    let detail=this.shareFilter(item?.flightDetailsList)+
    `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
    `Fare Type: ${ fare?.fareTypeDisplay }`+'\n'
    this.SelectedTInboundEmailData=this.SelectedTInboundEmailData.filter((items:any)=>items!==detail)
    let emaiapi:any={...item}
    emaiapi.fare=[fare]
    this.sendEmailApiData=this.sendEmailApiData.filter((items:any)=>items.source!==emaiapi.source||items.travelDuration!==emaiapi.travelDuration||items.fare[0].fareType!==emaiapi.fare[0].fareType||items.fare[0].baseFare!==emaiapi.fare[0].baseFare||items.fare[0].fareTypeDisplay!==emaiapi.fare[0].fareTypeDisplay||items.fare[0].finalTax!==emaiapi.fare[0].finalTax||items.flightDetailsList[0].fromAirport!==emaiapi.flightDetailsList[0].fromAirport||items.flightDetailsList[0].toAirport!==emaiapi.flightDetailsList[0].toAirport||items.flightDetailsList[0].schArrivalTime!==emaiapi.flightDetailsList[0].schArrivalTime||items.flightDetailsList[0].schDepartureTime!==emaiapi.flightDetailsList[0].schDepartureTime)

  }
  // console.log(this.SelectedTInboundEmailData)
  }
  selectFShareData(event:any,item:any,fare:any){
    if(event.checked){
      let emaiapi:any={...item}
      emaiapi.fare=[fare]
    this.sendEmailApiData.push(emaiapi)
    // `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
         this.SelectedFInboundEmailData.push(this.shareFilter(item?.flightDetailsList)+
         `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
         `Fare Type: ${ fare?.fareTypeDisplay }`+'\n')
        
    } else{
      // `${item?.flightDetailsList[0]?.carrierName}${ item?.flightDetailsList[0]?.flightNumber} ${ this.returnflight[1]?.fromAirport }${ this.returnflight[1]?.toAirport } ${ this.dateFormatMMM(item?.schDepartureTime)} ${ this.dateFormatHH(item?.schDepartureTime) } ${this.dateFormatHH( item?.schArrivalTime) }`+'\n'
      let detail=this.shareFilter(item?.flightDetailsList)+
      `Ticket Cost: INR ${ fare?.baseFare + fare?.finalTax+fare?.commercialData?.finalAmount }`+'\n'+
      `Fare Type: ${ fare?.fareTypeDisplay }`+'\n'
      let emaiapi:any={...item}
  emaiapi.fare=[fare]
      this.SelectedFInboundEmailData=this.SelectedFInboundEmailData.filter((items:any)=>items!==detail)
      this.sendEmailApiData=this.sendEmailApiData.filter((items:any)=>items.source!==emaiapi.source||items.travelDuration!==emaiapi.travelDuration||items.fare[0].fareType!==emaiapi.fare[0].fareType||items.fare[0].baseFare!==emaiapi.fare[0].baseFare||items.fare[0].fareTypeDisplay!==emaiapi.fare[0].fareTypeDisplay||items.fare[0].finalTax!==emaiapi.fare[0].finalTax||items.flightDetailsList[0].fromAirport!==emaiapi.flightDetailsList[0].fromAirport||items.flightDetailsList[0].toAirport!==emaiapi.flightDetailsList[0].toAirport||items.flightDetailsList[0].schArrivalTime!==emaiapi.flightDetailsList[0].schArrivalTime||items.flightDetailsList[0].schDepartureTime!==emaiapi.flightDetailsList[0].schDepartureTime)

    }
    }

distancePlus(distance:any){

let item=0
  for(let items of distance){
   
  item += Number(items?.distance)||0

}
if(item===0){
  return ''

}else{
  return item+(distance[0].unit?(distance[0].unit):' Miles')

}
}

carbonPlus(item:any){
  let itms=0
  for(let items of item){
   
  itms += items?.carbonEmission?.emission?.economy||0

}
return itms/1000
}
carbonfirstPlus(item:any){
  let itms=0
  for(let items of item){

  itms += items?.carbonEmission?.emission?.first||0
    
}
return itms/1000
}
carbonpremiumEconomyPlus(item:any){
  let itms=0
  for(let items of item){

  itms += items?.carbonEmission?.emission?.premiumEconomy||0
    
}
return itms/1000
}
carbonbusinessPlus(item:any){
  let itms=0
  for(let items of item){

  itms += items?.carbonEmission?.emission?.business||0
    
}
return itms/1000
}

// imageData(){
//   let data= this.FlightService.downloadImages()
//   console.log(data)
// for(let i=0;i<data.length;i++){
//   let flight:any={

//   }
//   flight["carrierCode"]=data[i].id
//   flight["flightName"]=data[i].name
//   flight["logo"]=data[i].logo
  
// this.carrierCode.push(flight)
  
  

      
//    }
// }
convertjson(item:any){
 if(item){
  return JSON.parse(item)

}else{
  return item
 }
}
filterCharges(item:any){
let airlineAmount:any
let platform:any

airlineAmount=item.filter((item:any)=>item.type==='airline')
platform=item.filter((item:any)=>item.type==='platform')

if(airlineAmount[0]?.amount===0){
  return 'Non Refundable'

}else{
  return airlineAmount[0]?.amount+' '+ airlineAmount[0]?.currency
  // platform[0]?.amount?('+'):''+platform[0]?.amount +' '+ platform[0]?.currency
}
}

scheduleFilter(item:any)
{
item=item.split(':')
if(item[1]==='h'||item[1]==='H'){
let hours="hours"
return item[0]+' hours'
}else if(item[1]==='d'||item[1]==='D'){
  return item[0]+' days'

}else{
  return ''
}
 }


 transform(htmlData: string, category: string): string {
  // Use regular expressions or string manipulation to filter data by category
  const startTag = `${category}`;
  const startIndex = htmlData.indexOf(startTag);
  if (startIndex === -1) {
    return ''; // Category not found
  }
  const endIndex = htmlData.indexOf('<p style=\"font-size:8.5pt;margin:0;\"><br></p>', startIndex);
  if (endIndex === -1) {
    return ''; // End tag not found
  }
  return htmlData.substring(startIndex, endIndex);
}
@ViewChild('tabGroup') tabGroup!: MatTabGroup;

onClickCancellationTab(){
  this.tabGroup.selectedIndex = 2;
}
onClickITINERARYTab(){
  this.tabGroup.selectedIndex = 0;

}





calculateDateDifference(departureDate:any, arrivalDate:any) {
  // Parse the dates
  let departure:any = new Date(departureDate);
  let arrival:any = new Date(arrivalDate);

  // Calculate the difference in milliseconds
  const difference = arrival - departure;

  // Convert difference from milliseconds to days
  const days = difference / (1000 * 60 * 60 * 24);

  // Format the output
  if(days <= 0) {
      return "";
  } else {
    if(Math.round(days)!=0){
      return `+${Math.round(days)} DAY`; // Rounds the days to the nearest whole number

    }else{
      return ''
    }
  }
}


getrepriceData(flights:any,returnFlights:any,thirdFlights:any,fourthFlights:any){

  let lastflight :any
 let returnLastFlight:any
 let thirdLastflight :any
 let fourthLastFlight:any
  let data:any=[]
  if(returnFlights &&!thirdFlights &&! fourthFlights){
    for(let i=0;i<flights.flightDetailsList.length;i++){
      lastflight = flights?.flightDetailsList[flights?.flightDetailsList.length - 1];

      // this.flights.flightDetailsList[i].schArrivalTime=this.flights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.flights.flightDetailsList[i].schDepartureTime=this.flights.flightDetailsList[i].schDepartureTime.replace(' ','+')
      

      flights.flightDetailsList[i].bookingClasses=flights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===flights.fare[0].fareTypeDisplay&& item?.corporateFare === flights.fare[0].corporateFare)
    }
    for(let i=0;i<returnFlights.flightDetailsList.length;i++){
      returnLastFlight = returnFlights?.flightDetailsList[flights?.flightDetailsList.length - 1];

      // this.returnFlights.flightDetailsList[i].schArrivalTime=this.returnFlights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.returnFlights.flightDetailsList[i].schDepartureTime=this.returnFlights.flightDetailsList[i].schDepartureTime.replace(' ','+')
    

      returnFlights.flightDetailsList[i].bookingClasses=returnFlights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===returnFlights.fare[0].fareTypeDisplay&& item?.corporateFare === returnFlights.fare[0].corporateFare)
    }
     data={
      
      "paxCount": this.messageData?.adultCount+this.messageData?.childCount+this.messageData?.infantCount,
      "adultCount": this.messageData?.adultCount,
      "childCount": this.messageData?.childCount,
      "infantCount": this.messageData?.infantCount,
     // "prefAirSource": this.flights?.source,
      "selectedFlight": [
            {
              "otherData":flights?.otherData,
                "routeRequest":flights?.routeRequest,
                "source":flights?.routeRequest?.source,
                "fromAirport": flights?.flightDetailsList[0].fromAirport,
                "toAirport": lastflight?.toAirport,
                "flightDetailsList": flights?.flightDetailsList
  
            },
            {
              "otherData":returnFlights?.otherData,
              "routeRequest":returnFlights?.routeRequest,
              "source":returnFlights?.routeRequest?.source,
              "fromAirport": returnFlights?.flightDetailsList[0].fromAirport,
              "toAirport": returnLastFlight?.toAirport,
              "flightDetailsList": returnFlights?.flightDetailsList
  
          }
        ],
     
    } 
    //console.log(data)
  
  }else if(returnFlights &&thirdFlights &&! fourthFlights){
    for(let i=0;i<flights.flightDetailsList.length;i++){
      lastflight = flights?.flightDetailsList[flights?.flightDetailsList.length - 1];

      // this.flights.flightDetailsList[i].schArrivalTime=this.flights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.flights.flightDetailsList[i].schDepartureTime=this.flights.flightDetailsList[i].schDepartureTime.replace(' ','+')
      

      flights.flightDetailsList[i].bookingClasses=flights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===flights.fare[0].fareTypeDisplay&& item?.corporateFare === flights.fare[0].corporateFare)
    }
    for(let i=0;i<returnFlights.flightDetailsList.length;i++){
      returnLastFlight = returnFlights?.flightDetailsList[returnFlights?.flightDetailsList.length - 1];

      // this.returnFlights.flightDetailsList[i].schArrivalTime=this.returnFlights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.returnFlights.flightDetailsList[i].schDepartureTime=this.returnFlights.flightDetailsList[i].schDepartureTime.replace(' ','+')
    

      returnFlights.flightDetailsList[i].bookingClasses=returnFlights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===returnFlights.fare[0].fareTypeDisplay&& item?.corporateFare === returnFlights.fare[0].corporateFare)
    }

    for(let i=0;i<thirdFlights.flightDetailsList.length;i++){
      thirdLastflight = thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length - 1];

      // this.returnFlights.flightDetailsList[i].schArrivalTime=this.returnFlights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.returnFlights.flightDetailsList[i].schDepartureTime=this.returnFlights.flightDetailsList[i].schDepartureTime.replace(' ','+')
    

      thirdFlights.flightDetailsList[i].bookingClasses=thirdFlights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===thirdFlights.fare[0].fareTypeDisplay&& item?.corporateFare === thirdFlights.fare[0].corporateFare)
    }
     data={
      
      "paxCount": this.messageData?.adultCount+this.messageData?.childCount+this.messageData?.infantCount,
      "adultCount": this.messageData?.adultCount,
      "childCount": this.messageData?.childCount,
      "infantCount": this.messageData?.infantCount,
     // "prefAirSource": this.flights?.source,
      "selectedFlight": [
            {
              "otherData":flights?.otherData,
                "routeRequest":flights?.routeRequest,
                "source":flights?.routeRequest?.source,
                "fromAirport": flights?.flightDetailsList[0].fromAirport,
                "toAirport": lastflight?.toAirport,
                "flightDetailsList": flights?.flightDetailsList
  
            },
            {
              "otherData":returnFlights?.otherData,
              "routeRequest":returnFlights?.routeRequest,
              "source":returnFlights?.routeRequest?.source,
              "fromAirport": returnFlights?.flightDetailsList[0].fromAirport,
              "toAirport": returnLastFlight?.toAirport,
              "flightDetailsList": returnFlights?.flightDetailsList
  
          },
          {
            "otherData":thirdFlights?.otherData,
            "routeRequest":thirdFlights?.routeRequest,
            "source":thirdFlights?.routeRequest?.source,
            "fromAirport": thirdFlights?.flightDetailsList[0].fromAirport,
            "toAirport": thirdLastflight?.toAirport,
            "flightDetailsList": thirdFlights?.flightDetailsList

        }
        ],
     
    } 

  }else  if(returnFlights &&thirdFlights && fourthFlights){
    for(let i=0;i<flights.flightDetailsList.length;i++){
      lastflight = flights?.flightDetailsList[flights?.flightDetailsList.length - 1];

      // this.flights.flightDetailsList[i].schArrivalTime=this.flights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.flights.flightDetailsList[i].schDepartureTime=this.flights.flightDetailsList[i].schDepartureTime.replace(' ','+')
      

      flights.flightDetailsList[i].bookingClasses=flights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===flights.fare[0].fareTypeDisplay&& item?.corporateFare === flights.fare[0].corporateFare)
    }
    for(let i=0;i<returnFlights.flightDetailsList.length;i++){
      returnLastFlight = returnFlights?.flightDetailsList[returnFlights?.flightDetailsList.length - 1];

      // this.returnFlights.flightDetailsList[i].schArrivalTime=this.returnFlights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.returnFlights.flightDetailsList[i].schDepartureTime=this.returnFlights.flightDetailsList[i].schDepartureTime.replace(' ','+')
    

      returnFlights.flightDetailsList[i].bookingClasses=returnFlights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===returnFlights.fare[0].fareTypeDisplay&& item?.corporateFare === returnFlights.fare[0].corporateFare)
    }

    for(let i=0;i<thirdFlights.flightDetailsList.length;i++){
      thirdLastflight = thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length - 1];

      // this.returnFlights.flightDetailsList[i].schArrivalTime=this.returnFlights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.returnFlights.flightDetailsList[i].schDepartureTime=this.returnFlights.flightDetailsList[i].schDepartureTime.replace(' ','+')
    

      thirdFlights.flightDetailsList[i].bookingClasses=thirdFlights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===thirdFlights.fare[0].fareTypeDisplay&& item?.corporateFare === thirdFlights.fare[0].corporateFare)
    }

    for(let i=0;i<fourthFlights.flightDetailsList.length;i++){
      fourthLastFlight = fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length - 1];

      // this.returnFlights.flightDetailsList[i].schArrivalTime=this.returnFlights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.returnFlights.flightDetailsList[i].schDepartureTime=this.returnFlights.flightDetailsList[i].schDepartureTime.replace(' ','+')
    

      fourthFlights.flightDetailsList[i].bookingClasses=fourthFlights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===fourthFlights.fare[0].fareTypeDisplay&& item?.corporateFare === fourthFlights.fare[0].corporateFare)
    }
     data={
      
      "paxCount": this.messageData?.adultCount+this.messageData?.childCount+this.messageData?.infantCount,
      "adultCount": this.messageData?.adultCount,
      "childCount": this.messageData?.childCount,
      "infantCount": this.messageData?.infantCount,
     // "prefAirSource": this.flights?.source,
      "selectedFlight": [
            {
              "otherData":flights?.otherData,
                "routeRequest":flights?.routeRequest,
                "source":flights?.routeRequest?.source,
                "fromAirport": flights?.flightDetailsList[0].fromAirport,
                "toAirport": lastflight?.toAirport,
                "flightDetailsList": flights?.flightDetailsList
  
            },
            {
              "otherData":returnFlights?.otherData,
              "routeRequest":returnFlights?.routeRequest,
              "source":returnFlights?.routeRequest?.source,
              "fromAirport": returnFlights?.flightDetailsList[0].fromAirport,
              "toAirport": returnLastFlight?.toAirport,
              "flightDetailsList": returnFlights?.flightDetailsList
  
          },
          {
            "otherData":thirdFlights?.otherData,
            "routeRequest":thirdFlights?.routeRequest,
            "source":thirdFlights?.routeRequest?.source,
            "fromAirport": thirdFlights?.flightDetailsList[0].fromAirport,
            "toAirport": thirdLastflight?.toAirport,
            "flightDetailsList": thirdFlights?.flightDetailsList

        },
        {
          "otherData":fourthFlights?.otherData,
          "routeRequest":fourthFlights?.routeRequest,
          "source":fourthFlights?.routeRequest?.source,
          "fromAirport": fourthFlights?.flightDetailsList[0].fromAirport,
          "toAirport": fourthLastFlight?.toAirport,
          "flightDetailsList": fourthFlights?.flightDetailsList

      }
        ],
     
    } 


    
  }else{
    for(let i=0;i<flights.flightDetailsList.length;i++){
      lastflight = flights?.flightDetailsList[flights?.flightDetailsList.length - 1];

      // this.flights.flightDetailsList[i].schArrivalTime=this.flights.flightDetailsList[i].schArrivalTime.replace(' ','+')
      // this.flights.flightDetailsList[i].schDepartureTime=this.flights.flightDetailsList[i].schDepartureTime.replace(' ','+')
     
     
      
    flights.flightDetailsList[i].bookingClasses=flights.flightDetailsList[i].bookingClasses?.filter((item:any)=>item.fareTypeDisplay===flights.fare[0].fareTypeDisplay&& item?.corporateFare === flights.fare[0].corporateFare)
  }
    data={
      
      "paxCount": this.messageData?.adultCount+this.messageData?.childCount+this.messageData?.infantCount,
      "adultCount": this.messageData?.adultCount,
      "childCount": this.messageData?.childCount,
      "infantCount": this.messageData?.infantCount,
      //"prefAirSource": this.flights?.source,
      "selectedFlight": [
            {
              "otherData":flights?.otherData,
               "routeRequest":flights?.routeRequest,
                "source":flights?.routeRequest?.source,
                "fromAirport": flights?.flightDetailsList[0].fromAirport,
                "toAirport": lastflight?.toAirport,
                "flightDetailsList": flights?.flightDetailsList
  
            }
        ],
    
    } 
  
  }
 

  this.FlightService
  .getReprice(data)
  .subscribe({
    next : (res:any) => {
      if(res.length>0) {
       let item:any
       item=res  
         item[0].forEach((flight:any) => {
          if(flight.flightDetailsList){
          flight.flightDetailsList[0].bookingClasses.forEach((bookingClass:any) => {
            // this.fare.totalPrice += bookingClass.fareDetailsPerPassengerType.baseFare;
            // this.fare.totalTax += bookingClass.fareDetailsPerPassengerType.finalTax;
            
              // console.log(this.departureFlight)
            this.departureFlight.flightDetailsList[0].bookingClasses.forEach((dataBookingClass:any) => {
              if( dataBookingClass.fareDetailsPerPassengerType.passengerType===bookingClass.fareDetailsPerPassengerType.passengerType){

                  if(dataBookingClass.fareTypeDisplay===bookingClass.fareTypeDisplay){
                    if(dataBookingClass.corporateFare===bookingClass.corporateFare){

                  dataBookingClass.fareDetailsPerPassengerType=bookingClass.fareDetailsPerPassengerType}
                    }
                  }
                });
              // console.log(this.departureFlight)
          
  
          });}
        });
      

        if(returnFlights){

        item[1].forEach((flight:any) => {
          if(flight.flightDetailsList){

          flight.flightDetailsList[0].bookingClasses.forEach((bookingClass:any) => {
            // this.fare.totalPrice += bookingClass.fareDetailsPerPassengerType.baseFare;
            // this.fare.totalTax += bookingClass.fareDetailsPerPassengerType.finalTax;
            
            this.returnFlight.flightDetailsList[0].bookingClasses.forEach((dataBookingClass:any) => {
              if( dataBookingClass.fareDetailsPerPassengerType.passengerType===bookingClass.fareDetailsPerPassengerType.passengerType){

                  if(dataBookingClass.fareTypeDisplay===bookingClass.fareTypeDisplay){
                    if(dataBookingClass.corporateFare===bookingClass.corporateFare){

                    dataBookingClass.fareDetailsPerPassengerType=bookingClass.fareDetailsPerPassengerType
                    }}
                  }
        
                });
              
          
  
          });}
        });
      


        }

        if(thirdFlights){

          item[2].forEach((flight:any) => {
            if(flight.flightDetailsList){
  
            flight.flightDetailsList[0].bookingClasses.forEach((bookingClass:any) => {
              // this.fare.totalPrice += bookingClass.fareDetailsPerPassengerType.baseFare;
              // this.fare.totalTax += bookingClass.fareDetailsPerPassengerType.finalTax;
              
              this.thirdFlight.flightDetailsList[0].bookingClasses.forEach((dataBookingClass:any) => {
                if( dataBookingClass.fareDetailsPerPassengerType.passengerType===bookingClass.fareDetailsPerPassengerType.passengerType){

                    if(dataBookingClass.fareTypeDisplay===bookingClass.fareTypeDisplay){
                      if(dataBookingClass.corporateFare===bookingClass.corporateFare){

                      dataBookingClass.fareDetailsPerPassengerType=bookingClass.fareDetailsPerPassengerType
                      }}
                    }
          
                  });
                
            
    
            });}
          });
        
  
  
          }
          if(fourthFlights){

            item[3].forEach((flight:any) => {
              if(flight.flightDetailsList){
    
              flight.flightDetailsList[0].bookingClasses.forEach((bookingClass:any) => {
                // this.fare.totalPrice += bookingClass.fareDetailsPerPassengerType.baseFare;
                // this.fare.totalTax += bookingClass.fareDetailsPerPassengerType.finalTax;
                
                this.fourthFlight.flightDetailsList[0].bookingClasses.forEach((dataBookingClass:any) => {
                  if( dataBookingClass.fareDetailsPerPassengerType.passengerType===bookingClass.fareDetailsPerPassengerType.passengerType){

                      if(dataBookingClass.fareTypeDisplay===bookingClass.fareTypeDisplay){
                        if(dataBookingClass.corporateFare===bookingClass.corporateFare){

                        dataBookingClass.fareDetailsPerPassengerType=bookingClass.fareDetailsPerPassengerType
                        }}
    
                      }
            
                    });
                  
              
      
              });}
            });
          
    
    
            }



      let fare:any=0
  

   
      } else {   

      } 

    },error : (err) => {

    }
  }
)

}

multiSelectedTAB:any=0
ontabClick(index:any){
  this.multiSelectedTAB=index
}





private getTimeCategory(date: Date,time:any) {
  const uniqueDate = new Set<Date>();
  const commonNumbers: any[] = [];
  // for(let i=0;i< this.returnflight[0].flights.length;i++){

    if (uniqueDate.has(this.formatDate(time)
      )) {
      // If the number is already in the set, it's a common number
      commonNumbers.push(this.formatDate(time)
        );
    } else {
      // Otherwise, add it to the set
      uniqueDate.add(this.formatDate(time)
        );
    }
   

  // }
  let Ddata:any=[]
  Ddata=Array.from(uniqueDate)


  if ( date >= new Date(Ddata[0]+'T00:00:00.000+05:30') && date <=  new Date(Ddata[0]+'T08:00:00.000+05:30')) {
    return 'earlyMorning';
  } else if ( date >= new Date(Ddata[0]+'T08:00:00.000+05:30') && date  <= new Date(Ddata[0]+'T14:00:00.000+05:30')) {
    return 'morning';
  } else if ( date  >= new Date(Ddata[0]+'T14:00:00.000+05:30') && date  <= new Date(Ddata[0]+'T16:00:00.000+05:30')) {
    return 'afternoon';
  } else if ( date >= new Date(Ddata[0]+'T16:00:00.000+05:30') && date  <= new Date(Ddata[0]+'T20:00:00.000+05:30')) {
    return 'evening';
  } else {
    return 'night';
  }
}
fareType:any
fareRType:any
fareTType:any
fareFType:any

combineFilters() {
 
  this.allEmailData=[]
   this.SelectedEmailData=[]
  /*++++++++++++++++++++++++ oneWay+++++++++++++++++++++++*/
  let filteredData = this.returnflight[0].flights.filter((flight:any) => {
    // Filter by time
    if (this.filterTime&&this.filterTime.length > 0) {
      // const schDepartureTime = new Date(flight.schDepartureTime);
      // const hour = schDepartureTime.getHours();
      const schDepartureTime = new Date(flight.schDepartureTime);
      const category = this.getTimeCategory(schDepartureTime,flight.schDepartureTime);
      if (!this.filterTime.includes(category)) {
        return false;
      }
    }
// Filter by stops
    if (this.stop && this.stop > 0) {
      if (flight.hopCount != this.stop) {
        return false;
      }
    }

    // Filter by airlines
    if (this.airlines&&this.airlines.length > 0) {
      if (!this.airlines.includes(flight.flightDetailsList[0].carrierName)) {
        return false;
      }
    }
    if (this.value) {
      const hasValidFare = flight.fare.some((f: any) => 
        f.baseFare + f.finalTax + (f?.commercialData?.finalAmount || 0) >= this.value
      );
      if (!hasValidFare) {
        return false;
      }
    }

    if (this.fareType&&this.fareType.length>0) {
      
      var hasFareType = flight.fare.some((f: any) =>this.fareType.includes(f.fareTypeDisplay));
      if (!hasFareType) {
        return false;
      }
      
    }
    return true;
  });

  // console.log('Filtered Data:', filteredData);
  this.flightDetail=filteredData



}
combineRFilters(){
  this.allInboundEmailData=[]
  this.SelectedInboundEmailData=[]

 
  /*++++++++++++++++++++++++ Return +++++++++++++++++++++++*/
  if(this.returnFlightDetail){
    let filteredReturnData = this.returnflight[1].flights.filter((flight:any) => {
      // Filter by time
      if (this.filterTimeR&&this.filterTimeR.length > 0) {
        // const schDepartureTime = new Date(flight.schDepartureTime);
        // const hour = schDepartureTime.getHours();
        const schDepartureTime = new Date(flight.schDepartureTime);
        const category = this.getTimeCategory(schDepartureTime,flight.schDepartureTime);
        if (!this.filterTimeR.includes(category)) {
          return false;
        }
      }
  // Filter by stops
      if (this.stopR && this.stopR > 0) {
        if (flight.hopCount != this.stopR) {
          return false;
        }
      }
  
      // Filter by airlines
      if (this.airlinesR&&this.airlinesR.length > 0) {
        if (!this.airlinesR.includes(flight.flightDetailsList[0].carrierName)) {
          return false;
        }
      }
      if (this.valueR) {
        const hasValidFare = flight.fare.some((f: any) => 
          f.baseFare + f.finalTax + (f?.commercialData?.finalAmount || 0) >= this.valueR
        );
        if (!hasValidFare) {
          return false;
        }
      }
      if (this.fareRType&&this.fareRType.length>0) {
      
        var hasFareType = flight.fare.some((f: any) =>this.fareRType.includes(f.fareTypeDisplay));
        if (!hasFareType) {
          return false;
        }
        
      }
      return true;
    });
  
    this.returnFlightDetail=filteredReturnData}

}


combineTFilters(){
  this.allInboundTEmailData=[]
  this.SelectedTInboundEmailData=[]
/*++++++++++++++++++++++++ Third +++++++++++++++++++++++*/

if(this.thirdFlightDetail){
  let filteredThirdData = this.returnflight[2].flights.filter((flight:any) => {
    // Filter by time
    if (this.filterTimeT&&this.filterTimeT.length > 0) {
      // const schDepartureTime = new Date(flight.schDepartureTime);
      // const hour = schDepartureTime.getHours();
      const schDepartureTime = new Date(flight.schDepartureTime);
      const category = this.getTimeCategory(schDepartureTime,flight.schDepartureTime);
      if (!this.filterTimeT.includes(category)) {
        return false;
      }
    }
// Filter by stops
    if (this.stopT && this.stopT > 0) {
      if (flight.hopCount != this.stopT) {
        return false;
      }
    }

    // Filter by airlines
    if (this.airlinesT&&this.airlinesT.length > 0) {
      if (!this.airlinesT.includes(flight.flightDetailsList[0].carrierName)) {
        return false;
      }
    }
    if (this.valueT) {
      const hasValidFare = flight.fare.some((f: any) => 
        f.baseFare + f.finalTax + (f?.commercialData?.finalAmount || 0) >= this.valueT
      );
      if (!hasValidFare) {
        return false;
      }
    }
    if (this.fareTType&&this.fareTType.length>0) {
      
      var hasFareType = flight.fare.some((f: any) =>this.fareTType.includes(f.fareTypeDisplay));
      if (!hasFareType) {
        return false;
      }
      
    }
    return true;
  });

  this.thirdFlightDetail=filteredThirdData}
}

combineFFilters(){
/*++++++++++++++++++++++++ Fourth +++++++++++++++++++++++*/
this.allInboundFEmailData=[]
this.SelectedFInboundEmailData=[]


if(this.fourthFlightDetail){
  let fourthFlightDetail = this.returnflight[3].flights.filter((flight:any) => {
    // Filter by time
    if (this.filterTimeF&&this.filterTimeF.length > 0) {
      // const schDepartureTime = new Date(flight.schDepartureTime);
      // const hour = schDepartureTime.getHours();
      const schDepartureTime = new Date(flight.schDepartureTime);
      const category = this.getTimeCategory(schDepartureTime,flight.schDepartureTime);
      if (!this.filterTimeF.includes(category)) {
        return false;
      }
    }
// Filter by stops
    if (this.stopF && this.stopF > 0) {
      if (flight.hopCount != this.stopF) {
        return false;
      }
    }

    // Filter by airlines
    if (this.airlinesF&&this.airlinesF.length > 0) {
      if (!this.airlinesF.includes(flight.flightDetailsList[0].carrierName)) {
        return false;
      }
    }
    if (this.valueF) {
      const hasValidFare = flight.fare.some((f: any) => 
        f.baseFare + f.finalTax + (f?.commercialData?.finalAmount || 0) >= this.valueF
      );
      if (!hasValidFare) {
        return false;
      }
    }
    if (this.fareFType&&this.fareFType.length>0) {
      
      var hasFareType = flight.fare.some((f: any) =>this.fareFType.includes(f.fareTypeDisplay));
      if (!hasFareType) {
        return false;
      }
      
    }
    return true;
  });

  this.fourthFlightDetail=fourthFlightDetail}
}

copyToClipboard() {
  // Copy the text to the clipboard
  // navigator.clipboard.writeText();

  navigator.clipboard.writeText(this.allEmailData+this.allInboundEmailData+this.allInboundTEmailData+this.allInboundFEmailData)
      // .then(() => {
      //   window.location.href = `https://web.whatsapp.com/send?phone=${this.phoneNumber}?text=${encodeURIComponent(this.allEmailData+this.allInboundEmailData)}`;
      // })
      // .catch(err => {
      //   console.error('Error copying text to clipboard: ', err);
      // });
      this.toastMsgService.setMsg({msg : "Text Copied !",msgTitle:  "", msgType : "I"});


     
}


fareTypeMenu:any
fareTypeFilter(){
  const uniqueFareType=new Set<any>();
const commonFareType: any[] = [];
  let fareTypes:any=[]
  this.flightDetail.forEach((flight:any) =>
  flight.fare.forEach(( curr:any) =>{
    fareTypes.push(curr.fareTypeDisplay)
  })
);
for(let i=0;i< fareTypes.length;i++){

if (uniqueFareType.has(fareTypes[i])){
  // If the number is already in the set, it's a common number
  commonFareType.push(fareTypes[i]);
} else {
  // Otherwise, add it to the set
  uniqueFareType.add(fareTypes[i]);
}
}

this.fareTypeMenu = new Set([...uniqueFareType]);

}

fareRTypeMenu:any
fareRTypeFilter(){
  const uniqueFareType=new Set<any>();
const commonFareType: any[] = [];
  let fareTypes:any=[]
  this.flightDetail.forEach((flight:any) =>
  flight.fare.forEach(( curr:any) =>{
    fareTypes.push(curr.fareTypeDisplay)
  })
);
for(let i=0;i< fareTypes.length;i++){

if (uniqueFareType.has(fareTypes[i])){
  // If the number is already in the set, it's a common number
  commonFareType.push(fareTypes[i]);
} else {
  // Otherwise, add it to the set
  uniqueFareType.add(fareTypes[i]);
}
}

this.fareRTypeMenu = new Set([...uniqueFareType]);

}

fareTTypeMenu:any
fareTTypeFilter(){
  const uniqueFareType=new Set<any>();
const commonFareType: any[] = [];
  let fareTypes:any=[]
  this.flightDetail.forEach((flight:any) =>
  flight.fare.forEach(( curr:any) =>{
    fareTypes.push(curr.fareTypeDisplay)
  })
);
for(let i=0;i< fareTypes.length;i++){

if (uniqueFareType.has(fareTypes[i])){
  // If the number is already in the set, it's a common number
  commonFareType.push(fareTypes[i]);
} else {
  // Otherwise, add it to the set
  uniqueFareType.add(fareTypes[i]);
}
}

this.fareTTypeMenu = new Set([...uniqueFareType]);

}
fareFTypeMenu:any
fareFTypeFilter(){
  const uniqueFareType=new Set<any>();
const commonFareType: any[] = [];
  let fareTypes:any=[]
  this.flightDetail.forEach((flight:any) =>
  flight.fare.forEach(( curr:any) =>{
    fareTypes.push(curr.fareTypeDisplay)
  })
);
for(let i=0;i< fareTypes.length;i++){

if (uniqueFareType.has(fareTypes[i])){
  // If the number is already in the set, it's a common number
  commonFareType.push(fareTypes[i]);
} else {
  // Otherwise, add it to the set
  uniqueFareType.add(fareTypes[i]);
}
}

this.fareFTypeMenu = new Set([...uniqueFareType]);

}




scroll(el: HTMLElement) {
  el.scrollIntoView({behavior:'smooth'});
  }


  subjectEmail:any

allRequest(){
  if(this.addCC){
    if(this.addCC.length===0){
      this.addCC=""
    }
      }
  let request:any={

    sendBy:this.username,
    toEmail:this.addTO,
    ccEmail:this.addCC||"",
    bccEmail:'',
    body:this.returnflight,
    subject:this.subjectEmail,
    allOptions:this.returnflight,
    requestId:this.messageData.uuid,
    searchRequest:this.messageData
}
this.optionEmailSend(request)
}


selectedRequest(){
  if(this.addCC){
    if(this.addCC.length===0){
      this.addCC=""
    }
      }
  let request:any={

    sendBy:this.username,
    toEmail:this.addTO,
    ccEmail:this.addCC||"",
    bccEmail:'',
    body:this.sendEmailApiData,
    subject:this.subjectEmail,
    allOptions:this.returnflight,
    requestId:this.messageData.uuid,
    searchRequest:this.messageData

}
this.optionEmailSend(request)
}
optionEmailSend(request:any){

  this.FlightService.optionEmailSend(request)
  .subscribe({
    next : (res:any) => {
      if(res) {

       let data:any
       data=res  
       this.toastMsgService.setMsg({msg : "Email Sent Successfully ",msgTitle:  "Success", msgType : "I"});

      

       

      } else {    
        this.toastMsgService.setMsg({msg : "Email Sent Successfully ",msgTitle:  "Success", msgType : "I"});

      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : "Failed To Send Email ",msgTitle:  "Warning", msgType : "W"});

      
    }
  }

)

}
sortAirlineOrder:boolean=true
sortDepartOrder:boolean=true
sortArrivesOrder:boolean=true

combineFilter(item:any){ 
  // for(let i=0;i<this.returnflight[0].flights.length;i++){
  //   this.returnflight[0].flights[i].dropDown=false

       
  // }
  if(item==='airline'){


    
// this.flightDetail.sort((sort:any)=>sort.flightDetailsList[0].carrierName)
if(this.sortAirlineOrder){
  this.flightDetail.sort((a:any, b:any) => a.flightDetailsList[0].carrierName.localeCompare(b.flightDetailsList[0]?.carrierName));
}else{
  this.flightDetail.sort((a:any, b:any) => b.flightDetailsList[0].carrierName.localeCompare(a.flightDetailsList[0]?.carrierName));

}

this.sortAirlineOrder = !this.sortAirlineOrder;

  }
  if(item==='departs'){

    if(this.sortDepartOrder){
      this.flightDetail.sort((a:any, b:any) => a.schDepartureTime.localeCompare(b.schDepartureTime));
    
    }else{
      this.flightDetail.sort((a:any, b:any) => b.schDepartureTime.localeCompare(a.schDepartureTime));
    
    }
    
    this.sortDepartOrder = !this.sortDepartOrder;
  }
  if(item==='arrives'){
    if(this.sortArrivesOrder){
      this.flightDetail.sort((a:any, b:any) => a.schArrivalTime.localeCompare(b.schArrivalTime));
    
    }else{
      this.flightDetail.sort((a:any, b:any) => b.schArrivalTime.localeCompare(a.schArrivalTime));
    
    }
        this.sortArrivesOrder = !this.sortArrivesOrder;

  }
  if(item==='price'){
    if (this.sortByAsc) {
      this.flightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceA - priceB;
      });
    } else {
      this.flightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceB - priceA;
      });
    }
  }
  this.sortByAsc=!this.sortByAsc
//   console.log(this.flightDetail)

//  console.log(this.enableCheck)

//   this.enableCheckBox()
}

sortRAirlineOrder:boolean=true
sortRDepartOrder:boolean=true
sortRArrivesOrder:boolean=true
sortRByAsc:boolean=true
combineRFilter(item:any){ 
  // for(let i=0;i<this.returnflight[0].flights.length;i++){
  //   this.returnflight[0].flights[i].dropDown=false

       
  // }
  if(item==='airline'){


    
// this.flightDetail.sort((sort:any)=>sort.flightDetailsList[0].carrierName)
if(this.sortRAirlineOrder){
  this.returnFlightDetail.sort((a:any, b:any) => a.flightDetailsList[0].carrierName.localeCompare(b.flightDetailsList[0]?.carrierName));
}else{
  this.returnFlightDetail.sort((a:any, b:any) => b.flightDetailsList[0].carrierName.localeCompare(a.flightDetailsList[0]?.carrierName));

}

this.sortRAirlineOrder = !this.sortRAirlineOrder;

  }
  if(item==='departs'){

    if(this.sortRDepartOrder){
      this.returnFlightDetail.sort((a:any, b:any) => a.schDepartureTime.localeCompare(b.schDepartureTime));
    
    }else{
      this.returnFlightDetail.sort((a:any, b:any) => b.schDepartureTime.localeCompare(a.schDepartureTime));
    
    }
    
    this.sortRDepartOrder = !this.sortRDepartOrder;
  }
  if(item==='arrives'){
    if(this.sortRArrivesOrder){
      this.returnFlightDetail.sort((a:any, b:any) => a.schArrivalTime.localeCompare(b.schArrivalTime));
    
    }else{
      this.returnFlightDetail.sort((a:any, b:any) => b.schArrivalTime.localeCompare(a.schArrivalTime));
    
    }
        this.sortRArrivesOrder = !this.sortRArrivesOrder;

  }
  if(item==='price'){
    if (this.sortRByAsc) {
      this.returnFlightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceA - priceB;
      });
    } else {
      this.returnFlightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceB - priceA;
      });
    }
  }
  this.sortRByAsc=!this.sortRByAsc

}

sortTAirlineOrder:boolean=true
sortTDepartOrder:boolean=true
sortTArrivesOrder:boolean=true
sortTByAsc:boolean=true
combineTFilter(item:any){ 
  // for(let i=0;i<this.returnflight[0].flights.length;i++){
  //   this.returnflight[0].flights[i].dropDown=false

       
  // }
  if(item==='airline'){


    
// this.flightDetail.sort((sort:any)=>sort.flightDetailsList[0].carrierName)
if(this.sortTAirlineOrder){
  this.thirdFlightDetail.sort((a:any, b:any) => a.flightDetailsList[0].carrierName.localeCompare(b.flightDetailsList[0]?.carrierName));
}else{
  this.thirdFlightDetail.sort((a:any, b:any) => b.flightDetailsList[0].carrierName.localeCompare(a.flightDetailsList[0]?.carrierName));

}

this.sortTAirlineOrder = !this.sortTAirlineOrder;

  }
  if(item==='departs'){

    if(this.sortTDepartOrder){
      this.thirdFlightDetail.sort((a:any, b:any) => a.schDepartureTime.localeCompare(b.schDepartureTime));
    
    }else{
      this.thirdFlightDetail.sort((a:any, b:any) => b.schDepartureTime.localeCompare(a.schDepartureTime));
    
    }
    
    this.sortTDepartOrder = !this.sortTDepartOrder;
  }
  if(item==='arrives'){
    if(this.sortTArrivesOrder){
      this.thirdFlightDetail.sort((a:any, b:any) => a.schArrivalTime.localeCompare(b.schArrivalTime));
    
    }else{
      this.thirdFlightDetail.sort((a:any, b:any) => b.schArrivalTime.localeCompare(a.schArrivalTime));
    
    }
        this.sortTArrivesOrder = !this.sortTArrivesOrder;

  }
  if(item==='price'){
    if (this.sortTByAsc) {
      this.thirdFlightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceA - priceB;
      });
    } else {
      this.thirdFlightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceB - priceA;
      });
    }
  }
  this.sortTByAsc=!this.sortTByAsc

}


sortFAirlineOrder:boolean=true
sortFDepartOrder:boolean=true
sortFArrivesOrder:boolean=true
sortFByAsc:boolean=true
combineFFilter(item:any){ 
  // for(let i=0;i<this.returnflight[0].flights.length;i++){
  //   this.returnflight[0].flights[i].dropDown=false

       
  // }
  if(item==='airline'){


    
// this.flightDetail.sort((sort:any)=>sort.flightDetailsList[0].carrierName)
if(this.sortFAirlineOrder){
  this.fourthFlightDetail.sort((a:any, b:any) => a.flightDetailsList[0].carrierName.localeCompare(b.flightDetailsList[0]?.carrierName));
}else{
  this.fourthFlightDetail.sort((a:any, b:any) => b.flightDetailsList[0].carrierName.localeCompare(a.flightDetailsList[0]?.carrierName));

}

this.sortFAirlineOrder = !this.sortFAirlineOrder;

  }
  if(item==='departs'){

    if(this.sortFDepartOrder){
      this.fourthFlightDetail.sort((a:any, b:any) => a.schDepartureTime.localeCompare(b.schDepartureTime));
    
    }else{
      this.fourthFlightDetail.sort((a:any, b:any) => b.schDepartureTime.localeCompare(a.schDepartureTime));
    
    }
    
    this.sortFDepartOrder = !this.sortFDepartOrder;
  }
  if(item==='arrives'){
    if(this.sortFArrivesOrder){
      this.fourthFlightDetail.sort((a:any, b:any) => a.schArrivalTime.localeCompare(b.schArrivalTime));
    
    }else{
      this.fourthFlightDetail.sort((a:any, b:any) => b.schArrivalTime.localeCompare(a.schArrivalTime));
    
    }
        this.sortFArrivesOrder = !this.sortFArrivesOrder;

  }
  if(item==='price'){
    if (this.sortFByAsc) {
      this.fourthFlightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceA - priceB;
      });
    } else {
      this.fourthFlightDetail.sort((a:any, b:any) => {
        const priceA = a.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        const priceB = b.fare.reduce((acc:any, curr:any) => acc + curr.baseFare, 0);
        return priceB - priceA;
      });
    }
  }
  this.sortFByAsc=!this.sortFByAsc

}
Incv:any
net:any
rules:boolean=false
IncentiveBoolean(){
  this.FlightService.AIR_SHOW_INCENTIVE()
      .subscribe({
        next : (res:any) => {
          if(res) {
            let data=res
            // console.log(data[0])
          // console.log( this.domIn)
if(data.rule==='0'){
  this.rules=false

}else if(data.rule==='1'){
  this.rules=true

}

          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )
}


tripEnable:boolean=false
ENABLE_TRIP_MGMT(){

    this.UserService.ENABLE_TRIP_MGMT()
    .subscribe({
      next : (res:any) => {
        if(res) {
       if(res.policyType==='TRIP_MGMT'){
        if(res.rule==='1'){
this.tripEnable=true
        }else 
        if(res.rule==='2'){
          this.tripEnable=true
                    }else{
          this.tripEnable=false

        }
      
       }
 
      }else{

      }
      if(this.messageData==="default message"){

        if(this.tripEnable){
          
          this.router.navigate(["/app/trip"]);
        
        }else{
              this.router.navigate(["/app/flight"]);}}
    },error : (err) => {
      if(this.messageData==="default message"){

        if(this.tripEnable){
          
          this.router.navigate(["/app/trip"]);
        
        }else{
              this.router.navigate(["/app/flight"]);}}
        console.error("Error in fetching data");
      }
    }
  )
  
}












formatDates(val: Date) {
  let convertedValue:any = ""
  if(val){
  let datepipe = new DatePipe("en");
  //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
  convertedValue =  datepipe.transform(val, "dd-MMM-yyyy HH:mm:ss");
  }
  return convertedValue;
}
selectedRequestDownload(): void {
  // Map the data to the format of the Excel
  const mappedData = this.mapDataForExcel(this.sendEmailApiData);

  // Create a new workbook and add a worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Flight Data');

  // Apply header styles
  this.applyHeaderStyles(worksheet);

  // Add the mapped data to the worksheet
  mappedData.forEach((item) => {
    worksheet.addRow(item);
  });

  // Save workbook to a file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'styled-flight-data.xlsx';
    link.click();
  });
}
allRequestDownload() {
  let mappedData: any = []
  for (let flight of this.returnflight) {
    let flightss: any = []

    for (let flights of flight.flights) {
      for (let fare of flights.fare) {
        let data={...flights}
        data.fare=[{ ...fare }]
         flightss.push({ ...data })

        // Map the data to the format of the Excel
        mappedData = (this.mapDataALLForExcel(flightss));
      }
    }
  }
  // Create a new workbook and add a worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Flight Data');

  // Apply header styles
  this.applyHeaderStyles(worksheet);

  // Add the mapped data to the worksheet
  mappedData.forEach((item: any) => {
    worksheet.addRow(item);
  });

  // Save workbook to a file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'styled-flight-data.xlsx';
    link.click();
  });
}


mapDataForExcel(data: any[]): any[] {
  console.log(data)

  return data.map((flight: any, index: number) => {
    return flight.flightDetailsList.map((detail: any) => {
      return {
        'Bid#': index + 1,
        'Carrier Name': detail.carrierName,
        'Flight Number': detail.flightNumber,
        'From Airport': detail.fromAirport,
        'To Airport': detail.toAirport,
        'Scheduled Departure': this.formatDates(detail.schDepartureTime),
        'Scheduled Arrival': this.formatDates(detail.schArrivalTime),
        'Travel Duration': detail.travelDuration + ' mins',
        // 'Base Fare': flight.fare[0].baseFare,
        'Ticket Cost': flight.fare[0].baseFare + flight.fare[0].finalTax+flight?.fare[0]?.commercialData?.finalAmount,
        'Fare Type': flight.fare[0].fareTypeDisplay,
        'Refundable': flight.fare[0].refundable ? 'Yes' : 'No',
        'Meal Included': flight.fare[0].hasFreeMeal ? 'Yes' : 'No',
      };
    });
  }).flat(); // Flatten the array as we have multiple flightDetails
}
mapDataALLForExcel(data: any[]): any[] {
  return data.map((flight: any, index: number) => {
    return flight.flightDetailsList.map((detail: any) => {
      return {
        'Bid#': index + 1,
        'Carrier Name': detail?.carrierName,
        'Flight Number': detail?.flightNumber,
        'From Airport': detail?.fromAirport,
        'To Airport': detail?.toAirport,
        'Scheduled Departure': this.formatDates(detail?.schDepartureTime),
        'Scheduled Arrival': this.formatDates(detail?.schArrivalTime),
        'Travel Duration': detail?.travelDuration + ' mins',
        'Ticket Cost': flight.fare[0].baseFare + flight.fare[0].finalTax+flight?.fare[0]?.commercialData?.finalAmount,
        // 'Final Tax': flight?.fare[0]?.finalTax,
        'Fare Type': flight?.fare[0]?.fareTypeDisplay,
        'Refundable': flight?.fare[0]?.refundable ? 'Yes' : 'No',
        'Meal Included': flight?.fare[0]?.hasFreeMeal ? 'Yes' : 'No',
      };
    });
  }).flat();;
  // Flatten the array as we have multiple flightDetails
}

applyHeaderStyles(worksheet: ExcelJS.Worksheet): void {
  // Define the headers
  worksheet.columns = [
    { header: 'Bid#', key: 'Bid#', width: 15 },
    { header: 'Carrier Name', key: 'Carrier Name', width: 20 },
    { header: 'Flight Number', key: 'Flight Number', width: 20 },
    { header: 'From Airport', key: 'From Airport', width: 20 },
    { header: 'To Airport', key: 'To Airport', width: 20 },
    { header: 'Scheduled Departure', key: 'Scheduled Departure', width: 25 },
    { header: 'Scheduled Arrival', key: 'Scheduled Arrival', width: 25 },
    { header: 'Travel Duration', key: 'Travel Duration', width: 20 },
    // { header: 'Base Fare', key: 'Base Fare', width: 15 },
    { header: 'Ticket Cost', key: 'Ticket Cost', width: 15 },
    { header: 'Fare Type', key: 'Fare Type', width: 20 },
    { header: 'Refundable', key: 'Refundable', width: 15 },
    { header: 'Meal Included', key: 'Meal Included', width: 15 }
  ];

  // Apply styles to the first row (headers)
  const headerRow = worksheet.getRow(1);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // White text
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '0000FF' } // blue background
    };
  });
}

countdown: number = 600;
interval: any;
startTimer(): void {
  this.interval = setInterval(() => {
    if (this.countdown > 0) {
      this.countdown--;
    } else {
      // this.goBack()
     
      clearInterval(this.interval);
      // Timer has completed. You can add more logic here if needed.
    }
  }, 1000); // 1000 milliseconds = 1 second
}
convertSecondsToMinSec(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes} minutes ${remainingSeconds} seconds`;
}



openAutoResch(){
   let flightDetail:any={}
    let returnDetail:any={}
    let thirdDetail:any={}
    let fourthDetail:any={}
    console.log(this.fairbookingDetail)
    let selectFight = this.getSelectedFareOriginalFlight(this.departureFlight, this.fairbookingDetail)
    flightDetail = selectFight;
    // flightDetail={...this.departureFlight}
    // if(this.fairbookingDetail){
     
    //   flightDetail.fare=[this.fairbookingDetail]
    // }
    if(this.returnFlight){
    let selectRFight = this.getSelectedFareOriginalFlight(this.returnFlight, this.fairRbookingDetail)
    returnDetail = selectRFight;}
    // returnDetail={...this.returnFlight}
    
    // if(this.fairRbookingDetail){
    //   returnDetail.fare=[{...this.fairRbookingDetail}]
    // }
if(this.thirdFlight){
  let selectTFight = this.getSelectedFareOriginalFlight(this.thirdFlight, this.fairTbookingDetail)
  thirdDetail = selectTFight;
}
   
    // thirdDetail={...this.thirdFlight}

    // if(this.fairTbookingDetail){
    //   thirdDetail.fare=[{...this.fairTbookingDetail}]
    // }
    if(this.fourthFlight){
    let selectFFight = this.getSelectedFareOriginalFlight(this.fourthFlight, this.fairFbookingDetail)
    fourthDetail = selectFFight;}
    // fourthDetail={...this.fourthFlight}

    // if(this.fairFbookingDetail){
    //   fourthDetail.fare=[{...this.fairFbookingDetail}]
    // }


    let travellerDetails={child:this.messageData.childCount,
      adult:this.messageData.adultCount,
     infantCount:this.messageData.infantCount,}




    //  let url= "/app/book?flightBooking="+JSON.stringify(flightDetail)+"&returnDetail="+JSON.stringify(returnDetail)+"&travellerDetails="+JSON.stringify(travellerDetails);
    //  window.open(url);
     let orderData:any
     if( this.departureFlight&&!this.returnFlight&&!this.thirdFlight&&!this.fourthFlight){
      orderData={flightBookingDetails:[flightDetail],travellerDetails:travellerDetails}
     
      orderData.flightBookingDetails[0].fromAirport=flightDetail.flightDetailsList[0].fromAirport
      orderData.flightBookingDetails[0].toAirport=flightDetail.flightDetailsList[flightDetail.flightDetailsList.length-1].toAirport
    
    }else if(this.departureFlight&&this.returnFlight&&!this.thirdFlight&&!this.fourthFlight){
    
      orderData={flightBookingDetails:[flightDetail,returnDetail],travellerDetails:travellerDetails}
     
     
      orderData.flightBookingDetails[0].fromAirport=flightDetail.flightDetailsList[0].fromAirport
      orderData.flightBookingDetails[0].toAirport=flightDetail.flightDetailsList[flightDetail.flightDetailsList.length-1].toAirport
      
      orderData.flightBookingDetails[1].fromAirport=returnDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBookingDetails[1].toAirport=returnDetail.flightDetailsList[returnDetail.flightDetailsList.length-1].toAirport
     
    }else if(this.departureFlight&&this.returnFlight&&this.thirdFlight&&!this.fourthFlight){
    
      orderData={flightBookingDetails:[flightDetail,returnDetail,thirdDetail],travellerDetails:travellerDetails}
     
     
      orderData.flightBookingDetails[0].fromAirport=flightDetail.flightDetailsList[0].fromAirport
      orderData.flightBookingDetails[0].toAirport=flightDetail.flightDetailsList[flightDetail.flightDetailsList.length-1].toAirport
      
      orderData.flightBookingDetails[1].fromAirport=returnDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBookingDetails[1].toAirport=returnDetail.flightDetailsList[returnDetail.flightDetailsList.length-1].toAirport
      orderData.flightBookingDetails[2].fromAirport=thirdDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBookingDetails[2].toAirport=thirdDetail.flightDetailsList[thirdDetail.flightDetailsList.length-1].toAirport
     
    }
    else if(this.departureFlight&&this.returnFlight&&this.thirdFlight&&this.fourthFlight){
    
      orderData={flightBookingDetails:[flightDetail,returnDetail,thirdDetail,fourthDetail],travellerDetails:travellerDetails}
     
      orderData.flightBookingDetails[0].fromAirport=flightDetail.flightDetailsList[0].fromAirport
      orderData.flightBookingDetails[0].toAirport=flightDetail.flightDetailsList[flightDetail.flightDetailsList.length-1].toAirport
      
      orderData.flightBookingDetails[1].fromAirport=returnDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBookingDetails[1].toAirport=returnDetail.flightDetailsList[returnDetail.flightDetailsList.length-1].toAirport
      orderData.flightBookingDetails[2].fromAirport=thirdDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBookingDetails[2].toAirport=thirdDetail.flightDetailsList[thirdDetail.flightDetailsList.length-1].toAirport
      orderData.flightBookingDetails[3].fromAirport=fourthDetail.flightDetailsList[0].fromAirport
      
      orderData.flightBookingDetails[3].toAirport=fourthDetail.flightDetailsList[fourthDetail.flightDetailsList.length-1].toAirport
    }
orderData.orderPassengersId=this.messageData.passengerId
orderData.amendmentId=this.messageData?.amendId
    this.generateReschOrder(orderData);

}


    @Output() childClicked = new EventEmitter<void>();

  notifyParent() {
    this.childClicked.emit(); 
  }
generateReschOrder(data:any){
  this.showSpiner=true
    this.FlightService
        .generateAutoReschOrder(data)
        .subscribe({
          next: (res: any) => {
            this.showSpiner = false

              // location.reload();
this.notifyParent()
            if (res) {

              let item: any
              item = res
              // console.log(res.message)
      this.toastMsgService.setMsg({msg :res?.message,msgTitle : "Success", msgType : "I"});

              //  console.log(item?.orderNumber)
              // let url = "/app/book?id=" + this.SettingsService.transform(item?.orderNumber)
              // window.open(url);

            } else {
            }
          }, error: (err) => {
            console.log(err)
            this.toastMsgService.setMsg({ msg: err?.error?.errorMessage, msgTitle: "Warning", msgType: "W" });

            this.showSpiner = false


          }
        }
        )
}
}
